/*
* Copyright (c) 2017 SGS Europe. All rights reserved.
*
* This program is the CONFIDENTIAL and PROPRIETARY property of SGS Europe.
* Any unauthorised use, reproduction, or transfer of this program is strictly
* prohibited.
*
* File Name: GreenlightTechTools.js
*
* Description:	The class containing the functionality required by the Greenlight Technical Tools for measure distances, areas, colour density, barcodes, colour separation layers and text in piece of artwork.
*/

var g_oTechTools = {};
var g_oPayload = { type: null, width: null, height: null, lineLength: null, area: null, degrees: null, separations: [], barcodeMeasurements: [] };

(function () {
	"use strict";

	function TechToolsUI(oViewer, iApprovalId, oDoc, iDocumentType) {
		/**
		* Object to subscribe and publish custom events
		*/
		this.g_oEvents = {};

		this.g_oViewer = oViewer;
		this.g_iDocumentType = iDocumentType;
		this.g_oAnnotationViewer = oViewer.g_oAnnotationViewer;
		this.g_oArtworkViewer = oViewer.g_oArtworkViewer;
		this.g_iOrigin_x = 0;
		this.g_iOrigin_y = 0;
		this.g_iX = 0;
		this.g_iY = 0;

		// The abbreviation used to indicate an area measurement (i.e. if measurement was in feet then it would be square feet - 'sq ft'). Used in UI display strings.
		this.c_szAreaMeasurementAbbreviation = "sq";

		// The abbreviation used to indicate the units used for the angle measurement. Used in UI display strings.
		this.c_szAngleMeasurementUnitsAbbreviation = "deg";

		// Metric - mm
		this.c_szMeasurementSuffixMetric = "mm";
		this.c_dMeasurementFactorMetric = 25.4;

		// Imperial - in (Since the image is measured in dpi then it's 1:1)
		this.c_szMeasurementSuffixImperial = "in";
		this.c_dMeasurementFactorImperial = 1;

		// 0 = Metric, 1 = Imperial.
		this.c_iMeasurementUnitMetric = 0;
		this.c_iMeasurementUnitImperial = 1;
		this.g_szMeasurementSuffix = this.c_szMeasurementSuffixMetric;
		this.g_dMeasurementFactor = this.c_dMeasurementFactorMetric;

		this.g_eMeasurementTypes = {
			NONE: -1,
			POINTTOPOINT: 0,
			AREA: 1,
			HORIZONTAL: 2,
			VERTICAL: 3,
			BARCODE: 4,
			COLOURDENSITY: 5,
			TEXT: 6
		};

		this.g_iSelectedMeasurementType = this.g_eMeasurementTypes.NONE;

		this.g_iOriginalZoomLevel = 1;

		this.g_eExamTypes = {
			COLOURDENSITY: 0,
			BARCODE: 1,
			TEXT: 2
		};
		this.g_iExamTypeCode = this.g_eExamTypes.COLOURDENSITY;

		this.c_szFailedToExamineImage = "";
		this.c_szInfoMsgNoLiveTextFound = "";
		this.c_szInfoMsgNoBarcodeFound = "";
		this.c_szInfoMsgNoSeparationsShown = "";

		this.c_szSeparationPercentageClassName = "separationPercentage";
		this.c_szSeparationPercentageElementName = "." + this.c_szSeparationPercentageClassName;
		this.c_szSeparationPercentage_BarcodeClassName = "separationPercentage_Barcode";
		this.c_szSeparationPercentage_BarcodeElementName = "." + this.c_szSeparationPercentage_BarcodeClassName;

		this.c_iDisplayFontSize = 15 * g_oViewer.c_iDPI;
		this.c_szDisplayFont = this.c_iDisplayFontSize + "px Varela Round";
		this.c_szFillStyle = "#fff";
		this.c_szTextBaseline = "bottom";
		this.c_szTextAlign = "start";	// Accepted values: "start", "center", "end", "left", "right"

		this.g_iApprovalId = iApprovalId;
		this.g_iDocumentId = oDoc.documentId;

		this.g_szTextMeasurementTextContent = "";

		this.g_szTACFieldDefault = "";

		this.g_oTextMeasurementWordsArray = []; // The stored text measurements.
		this.g_oBarcodeMeasurementArray = []; // The stored barcode measurements.
		this.c_iDisplayMargin = 5; // The gap (in pixels) between the Barcode details displayed above the marquee area on the annotation canvas.

		// The highlight of the text area measurement box.
		this.g_oTextAreaHighlightBox = {
			iBeginX: 5 * g_oViewer.c_iDPI,
			iBeginY: 13 * g_oViewer.c_iDPI,
			iWidth: 5 * g_oViewer.c_iDPI,
			iHeight: 20 * g_oViewer.c_iDPI
		};
	}

	TechToolsUI.prototype.toolTypeChange = function (element, type) {
		/// <summary>
		/// Helper method that changes tool type when a new one is clicked.
		/// </summary>
		/// <param name="element">The element being clicked.</param>
		/// <param name="type">The annotation type that is being changed.</param>
		/// <returns></returns>
		if (type !== g_oTechTools.g_eMeasurementTypes.HORIZONTAL && type !== g_oTechTools.g_eMeasurementTypes.VERTICAL) {
			$("#divTechToolsDropDown").slideUp(200);
		}

		if ($(element).hasClass("techToolType")) {
			$(".techToolType").css("background-color", "");
			$(".annotationType").removeStyle();
			this.g_iSelectedMeasurementType = type;
		}

		$(element).css("background-color", "grey");

		// Change the cursor to a crosshair
		$('#AnnotationViewer').css("cursor", "crosshair");
		if (g_oViewer.g_oCompareMode === eCompareMode.SideBySide || g_oViewer.g_oCompareMode === eCompareMode.SideBySideDiff) {
			$('#CompareAnnotationViewer').css("cursor", "crosshair");
		}
		g_oAnnotations.g_szPrevCursorStyle = "crosshair";

		// Close all annotations
		$(".speechbubble").remove();
		for (var i = 0; i < g_oAnnotations.g_oAnnotationsMade.length; i++) {
			g_oAnnotations.g_oAnnotationsMade[i].g_bClosed = true;
		}

		switch (type) {
			case g_oTechTools.g_eMeasurementTypes.POINTTOPOINT:
				g_oAnnotations.g_oLastUsedTool = $("#divTechToolsPointToPoint");
				break;
			case g_oTechTools.g_eMeasurementTypes.AREA:
				g_oAnnotations.g_oLastUsedTool = $("#divTechToolsArea");
				break;
			case g_oTechTools.g_eMeasurementTypes.VERTICAL:
			case g_oTechTools.g_eMeasurementTypes.HORIZONTAL:
				break;
			case g_oTechTools.g_eMeasurementTypes.COLOURDENSITY:
				g_oAnnotations.g_oLastUsedTool = $("#divTechToolsDensity");
				break;
			case g_oTechTools.g_eMeasurementTypes.BARCODE:
				g_oAnnotations.g_oLastUsedTool = $("#divTechToolBarcode");
				break;
			case g_oTechTools.g_eMeasurementTypes.TEXT:
				g_oAnnotations.g_oLastUsedTool = $("#divTechToolsText");
				break;
			default:
				break;
		}

		g_oTechTools.g_oAnnotationViewer.redraw(false);
	};

	TechToolsUI.prototype.clearToolType = function () {
		/// <summary>
		/// Helper method that clears the tool type when called.
		/// </summary>

		// Slide up the tech tools options.
		$("#divTechToolsDropDown").slideUp(200);

		// Clear the highlighted option.
		$(".techToolType").css("background-color", "");

		//Change the cursor back
		$('#AnnotationViewer').css("cursor", "default");
		g_oAnnotations.g_szPrevCursorStyle = "default";

		$("#btnTechTools").parent().removeClass("selectedButton");

		g_oTechTools.g_iSelectedMeasurementType = g_oTechTools.g_eMeasurementTypes.NONE;
		changeCanvasFunction();

		// Clear any previous barcode measurement data.
		g_oTechTools.clearBarcodeMeasurementArray();
	};

	TechToolsUI.prototype.formatMeasuredDistance = function (measuredDistance) {
		/// <summary>
		/// Formats the specified measured distance to either 2 decimal places
		/// if the measured units preference is set to Metric or 4 decimal places
		/// if the preference is set to Imperial.
		/// </summary>
		/// <param name="measuredDistance">The measured distance to be formatted.</param>
		/// <returns>Returns a string containing the formatted value.</returns>
		var szFormattedText;

		if (g_oSettings.g_oUserSettings.UseMetricUnits) {
			szFormattedText = round(measuredDistance, 2).toFixed(2);
		}
		else {
			szFormattedText = round(measuredDistance, 4).toFixed(4);
		}

		return szFormattedText;
	};

	/**
	 * Create the examine image request and send it to the server.
	 * @param {object} oArtworkViewer - The artwork viewer.
	 * @param {object} oAnnotationViewer - The annotation viewer.
	 * @param {int} begin_x - The starting point x coordinate.
	 * @param {int} begin_y - The starting point y coordinate.
	 * @param {int} end_x - The ending point x coordinate.
	 * @param {int} end_y - The ending point y coordinate.
	 * @param {enum} examTypeCode - Type of examine request
	 * @param {any} iAnnotationId - The annotation.
	 */
	TechToolsUI.prototype.examineImage = function (oArtworkViewer, oAnnotationViewer, begin_x, begin_y, end_x, end_y, examTypeCode, iAnnotationId) {
		
		// Show spinners in separations area.
		g_oSeparations.ShowSpinners();

		// Remove any existing tech tool results.
		$(g_oTechTools.c_szSeparationPercentageElementName).remove();
		$(g_oTechTools.c_szSeparationPercentage_BarcodeElementName).remove();

		// Create the image request.
		var oExamineImageRequest = new ExamineImageRequest();
		oExamineImageRequest.DocumentName = oArtworkViewer.g_oDoc.documentName;
		oExamineImageRequest.DocumentId = oArtworkViewer.g_oDoc.documentId;
		oExamineImageRequest.PageNumber = oArtworkViewer.g_iCurrentPage;
		oExamineImageRequest.ConsumerId = oArtworkViewer.g_oDoc.consumerId;
		oExamineImageRequest.Dimensions.MinX = Math.max(0, begin_x);
		oExamineImageRequest.Dimensions.MaxX = Math.min(1, end_x);
		oExamineImageRequest.Dimensions.MinY = Math.max(0, begin_y);
		oExamineImageRequest.Dimensions.MaxY = Math.min(1, end_y);
		oExamineImageRequest.ExamTypeCode = examTypeCode;
		oExamineImageRequest.CurrentResolution = oArtworkViewer.g_iCurrentResolution;
		oExamineImageRequest.OriginalResolution = oArtworkViewer.g_oDoc.pages[oArtworkViewer.g_iCurrentPage - 1].documentResolutionPPI;
		oExamineImageRequest.RealtimeRenderReference = oArtworkViewer.g_szRealtimeRenderReference;
		oExamineImageRequest.AnnotationID = iAnnotationId;
		oExamineImageRequest.FullImageWidth = (typeof(oArtworkViewer.g_oaImages[0]) !== "undefined") ? oArtworkViewer.g_oaImages[0].ImageWidth : 0;
		oExamineImageRequest.FullImageHeight = (typeof(oArtworkViewer.g_oaImages[0]) !== "undefined") ? oArtworkViewer.g_oaImages[0].ImageHeight : 0;

		// Create the marquee dimensions.
		var oMarqueeDimensions = new ImageDimensions();
		oMarqueeDimensions.MinX = Math.max(0, begin_x);
		oMarqueeDimensions.MinY = Math.max(0, begin_y);
		oMarqueeDimensions.MaxX = Math.min(1, end_x);
		oMarqueeDimensions.MaxY = Math.min(1, end_y);

		/// Outline the image request to be sent up.
		var oJSON = {
			SessionId: g_szSessionId,
			oExamineImageRequest: oExamineImageRequest
		};

		// Send the examine image request.
		$.ajax({
			type: "POST",
			url: "TechTools/examineImage",
			data: JSON.stringify(oJSON),
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			success: function (response) {
				g_oTechTools.ExamineImageResponse_CH(response.Contents, oExamineImageRequest, oArtworkViewer, oAnnotationViewer, oMarqueeDimensions);
			},
			failure: function (response) {
				g_oGreenlightMessages.displayErrorBubble(g_oTechTools.c_szFailedToExamineImage);
			}
		});
	};

	/// <summary>
	/// The call handler for the Examine Image Request.
	/// This processes the response message and updates the UI accordingly.
	/// </summary>
	/// <param name="oResponseContents">The response contents.</param>
	/// <param name="oExamineImageRequest">The examine image request.</param>
	/// <param name="oCurrentCanvas">The current canvas.</param>
	/// <param name="oMarqueeDimensions">The marquee dimensions.</param>
	TechToolsUI.prototype.ExamineImageResponse_CH = function (oResponseContents, oExamineImageRequest, oArtworkViewer, oAnnotationViewer, oMarqueeDimensions) {
		var oExamineImageResponse = JSON.parse(oResponseContents);
		var oSeparationsArray = [];
		oSeparationsArray = (oExamineImageRequest.ExamTypeCode === this.g_eExamTypes.TEXT) ? oExamineImageResponse.WordsList : oExamineImageResponse;

		g_oPayload.separations = oSeparationsArray;
		var szTextContent = "";
		var currentFont;
		var currentFontSize;
		var dMinX = 1;
		var dMinY = 1;
		var dMaxX = 0;
		var dMaxY = 0;
		var iBarcodeDisplayTextCount = 0;
		g_oPayload.barcodeMeasurements.length = 0;
		var iTotalAreaCoverage = 0;

		if (g_oTechTools.g_oTextMeasurementWordsArray.length > 0) {		// If we already have words from a previous Text Measurement...
			g_oTechTools.g_oTextMeasurementWordsArray.length = 0;		// ...clear the array by resetting it's length.
		}

		// Outline the co-ordinates for the annotation handle.
		var iPointX = Math.max(g_oMarquee.g_iX, g_oMarquee.g_iOrigin_x) + g_oAnnotationActions.g_iDragRectOffset;
		var iPointY = Math.min(g_oMarquee.g_iY, g_oMarquee.g_iOrigin_y);

		// Get the transformed coordinates.
		var trueCoords = g_oMarquee.transformMarqueeCoordinatesForRotation(oArtworkViewer, false, false);
		var transformedCoordinates = TechToolsUI.prototype.transformCoordinates(trueCoords.iBeginPoint_X, trueCoords.iBeginPoint_Y, trueCoords.iEndPoint_X, trueCoords.iEndPoint_Y, trueCoords.iDragOffset_X, trueCoords.iDragOffset_Y, trueCoords.iCenterShift_X, trueCoords.iCenterShift_Y, oArtworkViewer);

		// De-rotate.
		g_oMarquee.derotateCanvasContext(oArtworkViewer.g_oAnnotationCanvas.g_oContext, oArtworkViewer.g_oAnnotationCanvas, oArtworkViewer.g_oAnnotationCanvas.g_oCanvas.width, oArtworkViewer.g_oAnnotationCanvas.g_oCanvas.height, oArtworkViewer.g_oAnnotationCanvas.g_oCanvas.width / 2, oArtworkViewer.g_oAnnotationCanvas.g_oCanvas.height / 2);
		oArtworkViewer.g_oAnnotationCanvas.g_oContext.save();

		// Determine if the coordinates are out of bounds.
		var bOutOfBounds = ((transformedCoordinates.concat().sort(sortAnnotationCoords.returnXMin)[0][0] < 0) || (transformedCoordinates.concat().sort(sortAnnotationCoords.returnXMax)[0][0] > 1) || (transformedCoordinates.concat().sort(sortAnnotationCoords.returnYMin)[0][1] < 0) || (transformedCoordinates.concat().sort(sortAnnotationCoords.returnYMax)[0][1] > 1));

		// Determine if annotation handles can be drawn.
		var bDrawAnnotationHandles = !g_oViewer.g_bReadOnly && oArtworkViewer.g_bMainCanvas && !bOutOfBounds;

		// Restore the context.
		oArtworkViewer.g_oAnnotationCanvas.g_oContext.restore();

		// Keep track of any annotation handles drawn as part of the render.
		var oAnnotationHandles = [];

		// Render the results.
		for (var szSeparationName in oSeparationsArray) {
			switch (oExamineImageRequest.ExamTypeCode) {
			
				case this.g_eExamTypes.COLOURDENSITY:

					// If the separation is not disabled, add the colour density measurement.
					if ($("#" + g_oSeparations.SanitiseSeparationName(szSeparationName)).attr("class").indexOf(g_oSeparations.SeparationDisabledClassName) === -1) {
						var percent = (Math.round((1 - ((parseInt(oSeparationsArray[szSeparationName][0])) / 255)) * 10000) / 100).toFixed(0);

						// Add additional percentage value
						iTotalAreaCoverage += parseInt(percent);
						// Add the percentage sign
						percent += "%";

						$("#" + g_oSeparations.SanitiseSeparationName(szSeparationName)).children(".innerSepDiv").prepend("<div class='" + g_oTechTools.c_szSeparationPercentageClassName + "'>" + percent + "</div>");
					}

					// If annotation handles can be drawn, add a single handle for this colour density measurement.
					if (bDrawAnnotationHandles && oAnnotationHandles.length == 0) {

						// Add coordinates to handle list.
						oAnnotationHandles.push({
							handleX: iPointX,
							handleY: iPointY,
							annotationCoordinates: transformedCoordinates,
							annotationData: g_oPayload
						});
					}
					break;

				case this.g_eExamTypes.BARCODE:

					// Only draw the barcode if the separation is enabled.
					if (g_oSeparations.IsSeparationEnabled(oArtworkViewer, szSeparationName)) {

						// Get the barcode details.
						var szCodeType = oSeparationsArray[szSeparationName][0].replace("_", " ");	// Replace references to 'result' with oSeparations.
						var szCodeData = oSeparationsArray[szSeparationName][1];
						var szWidthMagnification = oSeparationsArray[szSeparationName][2];
						var dBarcodeX = oSeparationsArray[szSeparationName][3];
						var dBarcodeY = oSeparationsArray[szSeparationName][4];
						var dBarcodeWidth = oSeparationsArray[szSeparationName][5];
						var dBarcodeHeight = oSeparationsArray[szSeparationName][6];

						// Get the barcode text.
						var szMagnificationText = (szWidthMagnification === "0" || szWidthMagnification === "∞" || szWidthMagnification === "Infinity") ? "" : " (" + szWidthMagnification + "%)";
						var szDisplayText = "(" + szSeparationName + ") " + szCodeType + ": " + szCodeData + szMagnificationText;

						// Add the barcode text to the separation.
						$("#" + g_oSeparations.SanitiseSeparationName(szSeparationName)).append("<div class=\"" + g_oTechTools.c_szSeparationPercentage_BarcodeClassName + "\" style=\"margin-top:5px\">" + szCodeType + ": " + szCodeData + szMagnificationText + "</div>");

						// Setup the annotation context for drawing.
						var annContext = oAnnotationViewer.g_oContext;
						annContext.fillStyle = g_oTechTools.c_szFillStyle;
						annContext.font = g_oTechTools.c_szDisplayFont;
						annContext.textBaseline = g_oTechTools.c_szTextBaseline;
						annContext.textalign = g_oTechTools.c_szTextAlign;

						// Add the barcode measurement information to the stored list.
						var oBarcodeMeasurement = new BarcodeMeasurement();
						oBarcodeMeasurement.ArtworkCanvasId = oArtworkViewer.g_szCanvasId;
						oBarcodeMeasurement.AnnotationCanvasId = oAnnotationViewer.g_szCanvasId;
						oBarcodeMeasurement.SeparationName = szSeparationName;
						oBarcodeMeasurement.CodeType = szCodeType;
						oBarcodeMeasurement.CodeData = szCodeData;
						oBarcodeMeasurement.DisplayText = szDisplayText;
						oBarcodeMeasurement.MarqueeCoordinates = deepCopyObject(oExamineImageRequest.Dimensions);
						oBarcodeMeasurement.widthMagnification = szWidthMagnification;
						oBarcodeMeasurement.X = parseFloat(dBarcodeX);
						oBarcodeMeasurement.Y = parseFloat(dBarcodeY);
						oBarcodeMeasurement.Width = parseFloat(dBarcodeWidth);
						oBarcodeMeasurement.Height = parseFloat(dBarcodeHeight);
						g_oTechTools.g_oBarcodeMeasurementArray.push(oBarcodeMeasurement);
						g_oPayload.barcodeMeasurements.push(oBarcodeMeasurement);

						// Render the barcode measurement info onto the marquee overlay.
						var oBarcodeCoordinates = g_oTechTools.renderBarcodeMeasurement(oAnnotationViewer, oArtworkViewer, oBarcodeMeasurement, iBarcodeDisplayTextCount);

						// If annotation handles can be drawn.
						if (bDrawAnnotationHandles) {

							// Create the annotation data for this barcode.
							var oBarcodeAnnotationData = deepCopyObject(g_oPayload);
							oBarcodeAnnotationData.barcodeMeasurements = [oBarcodeMeasurement];

							// Calculate the annotation handle position.
							var oHandleSize = g_oAnnotationActions.calculateAnnotationHandleSize(eAnnotationHandleTypes.CreateNewAnnotation);
							var iHandleDisplayCoordX = oBarcodeCoordinates.x - oHandleSize[0] - (oHandleSize[0] / 4);
							var iHandleDisplayCoordY = oBarcodeCoordinates.y - g_oTechTools.c_iDisplayFontSize - (oHandleSize[0] / 4);

							// Add coordinates to handle list.
							oAnnotationHandles.push({
								handleX: iHandleDisplayCoordX,
								handleY: iHandleDisplayCoordY,
								annotationCoordinates: null,
								annotationData: oBarcodeAnnotationData
							});
						}

						// Increase the barcode count.
						iBarcodeDisplayTextCount++;
					}
					break;

				case this.g_eExamTypes.TEXT:
					g_oTechTools.g_oTextMeasurementWordsArray.push(oSeparationsArray[szSeparationName]);

					if (oExamineImageResponse.AnnotationID < 0) {
						// Find the outlying boundaries of all word elements.
						if (oSeparationsArray[szSeparationName].Llx < dMinX) {
							dMinX = oSeparationsArray[szSeparationName].Llx;
						}

						if (oSeparationsArray[szSeparationName].Ury < dMinY) {
							dMinY = oSeparationsArray[szSeparationName].Ury;
						}

						if (oSeparationsArray[szSeparationName].Urx > dMaxX) {
							dMaxX = oSeparationsArray[szSeparationName].Urx;
						}

						if (oSeparationsArray[szSeparationName].Lly > dMaxY) {
							dMaxY = oSeparationsArray[szSeparationName].Lly;
						}

						// Show a newline if there is a change in style.
						if (currentFont !== oSeparationsArray[szSeparationName].FontName || currentFontSize !== oSeparationsArray[szSeparationName].FontSize) {
							currentFont = oSeparationsArray[szSeparationName].FontName;
							currentFontSize = oSeparationsArray[szSeparationName].FontSize;
							if (szTextContent !== "") {
								szTextContent += "<br> <br>";
							}

							szTextContent += "<i> <b>" + currentFont + " " + currentFontSize + "pt </b> </i> <br>";
						}

						szTextContent += oSeparationsArray[szSeparationName].TextContent;
						// No space after means a new line
						if (!oSeparationsArray[szSeparationName].SpaceAfter) {
							szTextContent += "<br>";
						}
					}
					break;

				default:
			}
		}

		// If we have annotation handles.
		if (oAnnotationHandles.length > 0) {
			
			// Draw the annotation handles.
			for (var i = 0; i < oAnnotationHandles.length; i++) {
				g_oAnnotationActions.drawAnnotationHandle([oAnnotationHandles[i].handleX, oAnnotationHandles[i].handleY], g_oSettings.g_oUserSettings.AnnotationColour, true, eAnnotationHandleTypes.CreateNewAnnotation, oArtworkViewer.g_oAnnotationCanvas.g_oContext);
			}

			// Set the pointer move event.
			changeCanvasFunction('#AnnotationViewer', "pointermove.annotationUI", function (e) {
				AnnotationAction.prototype.mouseMoveAnnotationHandles(e, oArtworkViewer, g_oAnnotationActions.g_oAnnotationCanvas, oAnnotationHandles, eAnnotationHandleTypes.CreateNewAnnotation);
			});

			// Set the pointer down event.
			changeCanvasFunction("#AnnotationViewer", "pointerdown.annotationUI", function (e) {
				AnnotationAction.prototype.mouseClickAnnotationHandles(e, oArtworkViewer, g_oAnnotationActions.g_oAnnotationCanvas, oAnnotationHandles, eAnnotationHandleTypes.CreateNewAnnotation);
			});
		}

		//Set the TAC (Total Area Coverage)
		if (oExamineImageRequest.ExamTypeCode === this.g_eExamTypes.COLOURDENSITY) {
			// Set the default if first pass through, else reset to just text.
			if (this.g_szTACFieldDefault === "") {
				this.g_szTACFieldDefault = $('#td_TAC').text();
			} else {
				$('#td_TAC').text(this.g_szTACFieldDefault);
			}

			//Set the value
			$('#td_TAC').text($('#td_TAC').text() + iTotalAreaCoverage + "%");
			$('#td_TAC').show();

		} else {
			$('#td_TAC').hide();
		}


		// Create annotation for selected text ONLY if we are on the current approval doc
		if ((oExamineImageRequest.ExamTypeCode == g_oTechTools.g_eExamTypes.TEXT) && (g_szSessionId !== 0)) {
			if (((oSeparationsArray !== undefined) && (oSeparationsArray !== null)) && oSeparationsArray.length > 0) {
				if (oExamineImageResponse.AnnotationID < 0) {

					// We have a new Text Measurement. Time to create a fresh annotation.
					var iImageWidth = oArtworkViewer.g_iScaledImageWidth;
					var iImageHeight = oArtworkViewer.g_iScaledImageHeight;

					// Calculate the compare offset of the canvas.
					var compareOffset_x, compareOffset_y;
					var co = g_oCompare.calculateCompareOffsetInPx(oArtworkViewer);
					compareOffset_x = co.x;
					compareOffset_y = co.y;

					// These coordinates get pushed into the g_oAnnotations.g_oTempAnnotationArray by the AnnotationUI.prototype.annotationPointerUp function.
					// They need to be covered from the Adobe PDF coordinates back into pixel values.
					g_oAnnotations.g_oTempAnnotationArray.length = 0;	// Clearing the temporary annotation coordinate array.
					oAnnotationViewer.g_iOrigin_x = round((dMinX * iImageWidth) + compareOffset_x); // lower left x
					oAnnotationViewer.g_iOrigin_y = round((dMinY * iImageHeight) + compareOffset_y); // upper right y
					oAnnotationViewer.g_iX = round((dMaxX * iImageWidth) + compareOffset_x); // upper right x
					oAnnotationViewer.g_iY = round((dMaxY * iImageHeight) + compareOffset_y); // lower left y
					g_oAnnotations.g_iApprovalId = g_oTechTools.g_iApprovalId;
					g_oAnnotations.g_oAnnotationColSelected = g_oSettings.g_oUserSettings.AnnotationColour;
					g_oAnnotations.g_iAnnotationType = eAnnotationTypes.TextMeasurement;

					// Update user preferences so that when the text measurement is complete, the next action will be another text measurement rather than the previously use annotation type.
					g_oSettings.g_oUserSettings.LastUsedAnnotationType = eAnnotationTypes.TextMeasurement;
					g_oSettings.syncSettings();

					g_oTechTools.g_szTextMeasurementTextContent = szTextContent;

					g_oAnnotations.setAnnotationRectangle(oAnnotationViewer, oArtworkViewer, oAnnotationViewer.g_oCanvas);
					g_oAnnotations.annotationPointerUp(undefined, false, oMarqueeDimensions, oArtworkViewer, oAnnotationViewer);
				}
				else {
					// We are re-highlighting the words for an existing Text Measurement annotation.
					var oJSON = {
						iAnnotationID: oExamineImageResponse.AnnotationID,
						oWordsArray: deepCopyArray(g_oTechTools.g_oTextMeasurementWordsArray)
					};

					EventService.publish("setExistingTextMeasurementAnnotationWordsList", oJSON);
					g_oTechTools.g_szTextMeasurementTextContent = "";
					g_oTechTools.g_oTextMeasurementWordsArray.length = 0;
				}
			}
			else if (!g_oAnnotations.g_bAnnotationsFound) {
				g_oGreenlightMessages.displayWarningBubble(g_oTechTools.c_szInfoMsgNoLiveTextFound);
			}
		}

		// If this is a text measurement.
		if (oExamineImageRequest.ExamTypeCode == g_oTechTools.g_eExamTypes.TEXT) {

			// Redraw the canvas.
			oAnnotationViewer.redraw(false);
		}
		// If this is a barcode measurement type, and we have found no barcodes in the area.
		else if (oExamineImageRequest.ExamTypeCode == g_oTechTools.g_eExamTypes.BARCODE && iBarcodeDisplayTextCount == 0) {

			// Display the warning bubble and redraw the canvas.
			g_oGreenlightMessages.displayWarningBubble(g_oTechTools.c_szInfoMsgNoBarcodeFound);
			oAnnotationViewer.redraw(false);
		}

		// Hide the seperation spinners.
		$(g_oSeparations.SpinnerElementName).hide();
	};

	// Gets the barcode measurements for a canvas.
	TechToolsUI.prototype.getBarcodeMeasurementArray = function (canvasId) {

		// Create a new array to store the barcode measurements.
		var oBarcodeMeasurementArray = [];

		// Loop through each of the stored barcode measurements.
		for (var i = 0; i < g_oTechTools.g_oBarcodeMeasurementArray.length; i++) {

			// If the barcode measurement is on this canvas.
			if (g_oTechTools.g_oBarcodeMeasurementArray[i].ArtworkCanvasId == canvasId || g_oTechTools.g_oBarcodeMeasurementArray[i].AnnotationCanvasId == canvasId) {

				// Add the barcode measurement to the list.
				oBarcodeMeasurementArray.push(g_oTechTools.g_oBarcodeMeasurementArray[i]);
			}
		}

		// Return the barcode measurements array.
		return oBarcodeMeasurementArray;
	}

	// Renders the barcode measurements for a canvas.
	TechToolsUI.prototype.renderCanvasBarcodeMeasurements = function (szArtworkCanvasId) {

		// Get the artwork and annotation canvas.
		var oArtworkCanvas = g_oViewer.getCanvas(szArtworkCanvasId);
		var oAnnotationCanvas = oArtworkCanvas.g_oAnnotationCanvas;

		// If the canvas passed in was an annotation canvas.
		if (oArtworkCanvas.g_iCanvasType == eCanvasType.Annotation) {

			// Get the artwork and annotation canvas.
			oAnnotationCanvas = g_oViewer.getCanvas(szArtworkCanvasId);
			oArtworkCanvas = g_oViewer.getLinkedArtworkCanvas(oAnnotationCanvas.g_szCanvasId);
		}

		// Get a list of any active barcode measurements for the canvas.
		var oBarcodeMeasurementArray = g_oTechTools.getBarcodeMeasurementArray(szArtworkCanvasId);

		// If we are using the barcode measurement tool, and barcodes have been found for this canvas.
		if ((g_oTechTools.g_iSelectedMeasurementType === g_oTechTools.g_eMeasurementTypes.BARCODE) && (oBarcodeMeasurementArray.length > 0)) {

			// If we are in an overlay compare mode.
			if (g_oViewer.g_oCompareMode == eCompareMode.Overlay ||
				g_oViewer.g_oCompareMode == eCompareMode.Blink ||
				g_oViewer.g_oCompareMode == eCompareMode.SliderHorizontal ||
				g_oViewer.g_oCompareMode == eCompareMode.SliderVertical) {

				// Do not redraw this barcode unless this is the current annotation canvas.
				if (oAnnotationCanvas.g_szCanvasId != g_oCompare.getAnnotationCanvasId()) {

					// Do not render the barocdes.
					return;
				}
			}

			// Redraw any barcode measurements for the canvas.
			for (var i = 0; i < oBarcodeMeasurementArray.length; i++) {
				g_oTechTools.renderBarcodeMeasurement(oAnnotationCanvas, oArtworkCanvas, oBarcodeMeasurementArray[i], i, i === 0);
			}
		}
	}

	// Pans to a specific barcode measurement.
	TechToolsUI.prototype.panToBarcode = function (event, iBarcodePosition) {
		event.preventDefault();
		event.stopPropagation();

		// Get the requested barcode to pan to.
		var oBarcode = g_oTechTools.g_oBarcodeMeasurementArray[iBarcodePosition];

		// Get the artwork and annotation viewer for the barcode.
		var oArtworkViewer = g_oViewer.getCanvas(oBarcode.ArtworkCanvasId);
		var oAnnotationViewer = g_oViewer.getCanvas(oBarcode.AnnotationCanvasId);

		/* Compare offset needs to be considered.
		// Calulate the compare offset on the artwork canvas.
		var compareOffset_x, compareOffset_y;
		var co = g_oCompare.calculateCompareOffsetInPx(oArtworkViewer);
		compareOffset_x = co.x;
		compareOffset_y = co.y;
		*/

		// Setup the pan to the barcode.
		var oBarcodeMidPoint = [oBarcode.MarqueeCoordinates.MinX + ((oBarcode.MarqueeCoordinates.MaxX - oBarcode.MarqueeCoordinates.MinX) / 2), oBarcode.MarqueeCoordinates.MinY + ((oBarcode.MarqueeCoordinates.MaxY - oBarcode.MarqueeCoordinates.MinY) / 2)];
		oArtworkViewer.g_iTempDragOffset_x = (oBarcodeMidPoint[0] * oArtworkViewer.g_iScaledImageWidth) - (oArtworkViewer.g_iScaledImageWidth / 2);
		oArtworkViewer.g_iTempDragOffset_y = (oBarcodeMidPoint[1] * oArtworkViewer.g_iScaledImageHeight) - (oArtworkViewer.g_iScaledImageHeight / 2);
		oArtworkViewer.g_iDragXDiff = (oArtworkViewer.g_iDragOffset_x - oArtworkViewer.g_iTempDragOffset_x) / oAnnotationViewer.g_iAnimateFrames;
		oArtworkViewer.g_iDragYDiff = (oArtworkViewer.g_iDragOffset_y - oArtworkViewer.g_iTempDragOffset_y) / oAnnotationViewer.g_iAnimateFrames;

		// Pan to the barcode.
		oArtworkViewer.g_oCanvasZoom.startZoomAnimate();
	}

	// Clears any current barcode measurements.
	TechToolsUI.prototype.clearBarcodeMeasurementArray = function () {

		// Clear any previous barcode measurement data.
		g_oTechTools.g_oBarcodeMeasurementArray.length = 0;
		g_oPayload.barcodeMeasurements.length = 0;
	}

	/**
	 * Renders a requested barcode measurement.
	 * @param {object} oAnnotationViewer - The annotation viewer.
	 * @param {object} oArtworkViewer - The artwork viewer.
	 * @param {object} oBarcodeMeasurements - The barcode measurement object.
	 * @param {int} iBarcodeDisplayTextCount - The number of barcode measurements.
	 * @param {bool} bRenderOverlayMarquee - Whether to render the overlay marquee.
	 */
	TechToolsUI.prototype.renderBarcodeMeasurement = function (oAnnotationViewer, oArtworkViewer, oBarcodeMeasurements, iBarcodeDisplayTextCount, bRenderOverlayMarquee) {

		// Get the annotation context.
		var oAnnotationViewerContext = oAnnotationViewer.g_oContext;

		// Take a copy of the barcode measurements object.
		var oBarcodeMeasurement = deepCopyObject(oBarcodeMeasurements);

		// Get the scaled image width and height.
		var iScaledImageWidth = oArtworkViewer.g_iScaledImageWidth;
		var iScaledImageHeight = oArtworkViewer.g_iScaledImageHeight;

		// Calculate the compare offset of the canvas.
		var compareOffset_x, compareOffset_y;
		var co = g_oCompare.calculateCompareOffsetInPx(oArtworkViewer);
		compareOffset_x = co.x;
		compareOffset_y = co.y;

		// Get the compare rotation of the canvas.
		var iCompareRotation = g_oCompare.getCompareRotation(oArtworkViewer);

		// If we have a compare rotation.
		if (iCompareRotation > 0) {

			// Rotate the origin by the compare rotation.
			var oRotatedOrigin = oArtworkViewer.rotate(oBarcodeMeasurement.MarqueeCoordinates.MinX, oBarcodeMeasurement.MarqueeCoordinates.MinY, 0.5, 0.5, iCompareRotation);
			oBarcodeMeasurement.MarqueeCoordinates.MinX = oRotatedOrigin.rotated_x;
			oBarcodeMeasurement.MarqueeCoordinates.MinY = oRotatedOrigin.rotated_y;

			// Rotate the co-ordinates by the compare rotation.
			var oRotatedCoordinates = oArtworkViewer.rotate(oBarcodeMeasurement.MarqueeCoordinates.MaxX, oBarcodeMeasurement.MarqueeCoordinates.MaxY, 0.5, 0.5, iCompareRotation);
			oBarcodeMeasurement.MarqueeCoordinates.MaxX = oRotatedCoordinates.rotated_x;
			oBarcodeMeasurement.MarqueeCoordinates.MaxY = oRotatedCoordinates.rotated_y;

			// If we have a compare rotation of 90 or 270, swap the image width and height.
			if (iCompareRotation == 90 || iCompareRotation == 270) {
				iScaledImageWidth = oArtworkViewer.g_iScaledImageHeight;
				iScaledImageHeight = oArtworkViewer.g_iScaledImageWidth;
			}
		}

		// Re-render the annotation viewer overlay to display the marquee selection. Used when panning the barcode measurement.
		if (bRenderOverlayMarquee !== undefined && bRenderOverlayMarquee !== null && bRenderOverlayMarquee) {

			// Generate the canvas coordinates for the rectangle marquee.
			g_oMarquee.g_iOrigin_x = (oBarcodeMeasurement.MarqueeCoordinates.MinX * iScaledImageWidth) + oArtworkViewer.g_iCenterShift_x + compareOffset_x;
			g_oMarquee.g_iOrigin_y = (oBarcodeMeasurement.MarqueeCoordinates.MinY * iScaledImageHeight) + oArtworkViewer.g_iCenterShift_y + compareOffset_y;
			g_oMarquee.g_iX = (oBarcodeMeasurement.MarqueeCoordinates.MaxX * iScaledImageWidth) + oArtworkViewer.g_iCenterShift_x + compareOffset_x;
			g_oMarquee.g_iY = (oBarcodeMeasurement.MarqueeCoordinates.MaxY * iScaledImageHeight) + oArtworkViewer.g_iCenterShift_y + compareOffset_y;

			// De-rotate the canvas back to 0 degree orientation so that the clearing an resetting the overlay will cover the desired area.
			g_oMarquee.derotateCanvasContext(oAnnotationViewerContext, oAnnotationViewer, oAnnotationViewer.g_oCanvas.width, oAnnotationViewer.g_oCanvas.height, oAnnotationViewer.g_oCanvas.width / 2, oAnnotationViewer.g_oCanvas.height / 2);

			// Clear the previous overlay.
			oAnnotationViewerContext.clearRect(0, 0, oAnnotationViewer.g_oCanvas.width, oAnnotationViewer.g_oCanvas.height);

			// Create a new opaque overlay.
			oAnnotationViewerContext.rect(0, 0, oAnnotationViewer.g_oCanvas.width, oAnnotationViewer.g_oCanvas.height);
			oAnnotationViewerContext.fillStyle = "rgba(0,0,0,0.75)";
			oAnnotationViewerContext.fill();

			// Reset the canvas context back to the current rotation.
			oAnnotationViewerContext.restore();

			// Clear the rectangle marquee in the current orientation.
			oAnnotationViewerContext.clearRect(g_oMarquee.g_iOrigin_x, g_oMarquee.g_iOrigin_y, g_oMarquee.g_iX - g_oMarquee.g_iOrigin_x, g_oMarquee.g_iY - g_oMarquee.g_iOrigin_y);
		}

		// Determine the display coordinates.
		var iDisplayCoordX = Math.min(g_oMarquee.g_iX, g_oMarquee.g_iOrigin_x);
		var iDisplayCoordY = Math.min(g_oMarquee.g_iY, g_oMarquee.g_iOrigin_y);

		// De-rotate.
		oArtworkViewer.g_oAnnotationCanvas.g_oContext.save();
		g_oMarquee.derotateCanvasContext(oArtworkViewer.g_oAnnotationCanvas.g_oContext, oArtworkViewer.g_oAnnotationCanvas, oArtworkViewer.g_oAnnotationCanvas.g_oCanvas.width, oArtworkViewer.g_oAnnotationCanvas.g_oCanvas.height, oArtworkViewer.g_oAnnotationCanvas.g_oCanvas.width / 2, oArtworkViewer.g_oAnnotationCanvas.g_oCanvas.height / 2);

		// Need to adjust the Y starting coordinate to take into account multiple lines of text to be displayed.
		iDisplayCoordY = iDisplayCoordY - (iBarcodeDisplayTextCount * (g_oTechTools.c_iDisplayFontSize + g_oTechTools.c_iDisplayMargin));

		// Now restore the canvas flipping it back to its original orientation.
		oAnnotationViewerContext.restore();

		// Prepare for writing the text.
		oAnnotationViewerContext.fillStyle = g_oTechTools.c_szFillStyle;
		oAnnotationViewerContext.font = g_oTechTools.c_szDisplayFont;
		oAnnotationViewerContext.textBaseline = g_oTechTools.c_szTextBaseline;
		oAnnotationViewerContext.textAlign = g_oTechTools.c_szTextAlign;

		// Write the text.
		oAnnotationViewerContext.fillText(oBarcodeMeasurement.DisplayText, iDisplayCoordX, iDisplayCoordY);

		// Return the coordinates we have drawn the barcode to.
		return { x: iDisplayCoordX, y: iDisplayCoordY };
	};

	/**
	 * Shows the separations side bar.
	 */
	TechToolsUI.prototype.showSeperationsSideBar = function () {

		// If a slide is required.
		if (!$("#divSepDiv").is(":visible")) {

			// Slide the div.
			slideDiv($("#divSepContainer"), false, true);

			// Update the user settings.
			g_oSettings.syncSettings();
		}
	};

	/**
	 * Hides the separations side bar.
	 */
	TechToolsUI.prototype.hideSeperationsSideBar = function () {

		// If a slide is required.
		if ($("#divSepDiv").is(":visible")) {

			// Slide the div.
			slideDiv($("#divSepContainer"), false, true);

			// Update the user settings.
			g_oSettings.syncSettings();
		}
	};

	/// <summary>
	/// Handles the different type of measurements and updates the UI with the required details dependant on the selected measurement type.
	/// The long list of parameters are not all required by this method but form an interface used by the MarqueeService which draws the
	/// marquee on the canvas and then calls implementation specific functions (i.e. this function).
	/// </summary>
	/// <param name="oAnnotationCanvasContext">The annotation canvas context.</param>
	/// <param name="iCoordinateDistance_x">The X coordinate distance (the distance between the begin and end points).</param>
	/// <param name="iCoordinateDistance_y">The Y coordinate distance (the distance between the begin and end points).</param>
	/// <param name="beginPoint_x">The start X coordinate.</param>
	/// <param name="beginPoint_y">The start Y coordinate.</param>
	/// <param name="canvasWidth">Width of the canvas.</param>
	/// <param name="canvasHeight">Height of the canvas.</param>
	/// <param name="canvasHalfWidth">The half width of the canvas.</param>
	/// <param name="canvasHalfHeight">The half height of the canvas.</param>
	TechToolsUI.prototype.measurementMarqueeDraw = function (oArtworkViewer, oAnnotationViewer, oAnnotationCanvasContext, iCoordinateDistance_x, iCoordinateDistance_y, beginPoint_x, beginPoint_y, canvasWidth, canvasHeight, canvasHalfWidth, canvasHalfHeight) {
		
		if (g_oTechTools.g_iSelectedMeasurementType === g_oTechTools.g_eMeasurementTypes.BARCODE) {	
			return;
		}
		// Set the measurement units and display suffixes.
		if (g_oSettings.g_oUserSettings.UseMetricUnits) {
			g_oTechTools.g_szMeasurementSuffix = g_oTechTools.c_szMeasurementSuffixMetric;
			g_oTechTools.g_dMeasurementFactor = g_oTechTools.c_dMeasurementFactorMetric;
		}
		else {
			g_oTechTools.g_szMeasurementSuffix = g_oTechTools.c_szMeasurementSuffixImperial;
			g_oTechTools.g_dMeasurementFactor = g_oTechTools.c_dMeasurementFactorImperial;
		}

		var artworkViewerImage = oArtworkViewer.g_oaImages[0];
		var scaleFactor = artworkViewerImage.ImageWidth / oArtworkViewer.g_iScaledImageWidth;

		var scaledDistance_x = (iCoordinateDistance_x * scaleFactor / artworkViewerImage.WidthResolution) * g_oTechTools.g_dMeasurementFactor;
		var scaledDistance_y = (iCoordinateDistance_y * scaleFactor / artworkViewerImage.HeightResolution) * g_oTechTools.g_dMeasurementFactor;

		g_oTechTools.g_iOriginalZoomLevel = oArtworkViewer.g_iZoomLevel;

		switch (g_oTechTools.g_iSelectedMeasurementType) {
			case g_oTechTools.g_eMeasurementTypes.POINTTOPOINT:
				g_oTechTools.measurePointToPoint(oArtworkViewer, oAnnotationViewer, oAnnotationCanvasContext, beginPoint_x, beginPoint_y, scaledDistance_x, scaledDistance_y, iCoordinateDistance_x, iCoordinateDistance_y, g_oPayload);
				g_oPayload.type = eAnnotationTypes.Line;
				break;

			case g_oTechTools.g_eMeasurementTypes.AREA:
				g_oTechTools.measureArea(oArtworkViewer, oAnnotationViewer, oAnnotationCanvasContext, beginPoint_x, beginPoint_y, scaledDistance_x, scaledDistance_y, iCoordinateDistance_x, iCoordinateDistance_y, g_oPayload);
				g_oPayload.type = eAnnotationTypes.Rectangle;
				break;

			case g_oTechTools.g_eMeasurementTypes.HORIZONTAL:
				MeasureHorizontal(oArtworkViewer, oAnnotationViewer, oAnnotationCanvasContext, beginPoint_x, beginPoint_y, scaledDistance_x, iCoordinateDistance_x, iCoordinateDistance_y, canvasWidth, canvasHeight, canvasHalfWidth, canvasHalfHeight);
				break;

			case g_oTechTools.g_eMeasurementTypes.VERTICAL:
				MeasureVertical(oArtworkViewer, oAnnotationViewer, oAnnotationCanvasContext, beginPoint_x, beginPoint_y, scaledDistance_y, iCoordinateDistance_x, iCoordinateDistance_y, canvasWidth, canvasHeight, canvasHalfWidth, canvasHalfHeight);
				break;

			case g_oTechTools.g_eMeasurementTypes.BARCODE:
			case g_oTechTools.g_eMeasurementTypes.COLOURDENSITY:
			case g_oTechTools.g_eMeasurementTypes.TEXT:
			default:
			// Do nothing.
		}
	};

		/** 
		* Function to calculate the point to point measurement and render it in the UI.
		* @param canvasContext - The canvas context.
		* @param {number} beginPoint_x - The start X coordinate.
		* @param {number} beginPoint_y - The start Y coordinate.
		* @param {number} scaledDistance_x - The X coordinate distance (the distance between the begin and end points) scaled by the image width.
		* @param {number} scaledDistance_y - The Y coordinate distance (the distance between the begin and end points) scaled by the image height.
		* @param {number} coordinateDistance_x - The X coordinate distance (the distance between the begin and end points).
		* @param {number} coordinateDistance_y - The Y coordinate distance (the distance between the begin and end points).
	    */
	TechToolsUI.prototype.measurePointToPoint = function (oArtworkViewer, oAnnotationViewer, canvasContext, beginPoint_x, beginPoint_y, scaledDistance_x, scaledDistance_y, coordinateDistance_x, coordinateDistance_y, payload) {
		canvasContext.fillStyle = g_oTechTools.c_szFillStyle;
		canvasContext.font = g_oTechTools.c_szDisplayFont;
		canvasContext.textBaseline = g_oTechTools.c_szTextBaseline;
		canvasContext.textAlign = g_oTechTools.c_szTextAlign;

		if (scaledDistance_x > 0) {
			canvasContext.fillText(g_oTechTools.formatMeasuredDistance(scaledDistance_x) + " " + g_oTechTools.g_szMeasurementSuffix, beginPoint_x, beginPoint_y);
			payload.width = g_oTechTools.formatMeasuredDistance(scaledDistance_x) + " " + g_oTechTools.g_szMeasurementSuffix;
		}
		var iTextHeight = 30; // this value is larger than actually required as the text appears on a diagonal, meaning some overlap is possible.
		// Point 2 point measurement
		var hypotenuse = Math.sqrt((scaledDistance_x * scaledDistance_x) + (scaledDistance_y * scaledDistance_y));

		// 57.2958 is not a magic number. It is a radian!
		var angle = Math.atan(coordinateDistance_y / coordinateDistance_x) * 57.2958;

		// Reverse the angle to make sure the measurement figure is correctly oriented
		if (((g_oMarquee.g_iX < g_oMarquee.g_iOrigin_x) && (g_oMarquee.g_iY > g_oMarquee.g_iOrigin_y))
			||
			((g_oMarquee.g_iX > g_oMarquee.g_iOrigin_x) && (g_oMarquee.g_iY < g_oMarquee.g_iOrigin_y))) {
			angle -= angle * 2;
		};

		canvasContext.beginPath();
		canvasContext.moveTo(g_oMarquee.g_iOrigin_x, g_oMarquee.g_iOrigin_y);
		canvasContext.lineTo(g_oMarquee.g_iX, g_oMarquee.g_iY);
		canvasContext.strokeStyle = ((scaledDistance_x === 0 || scaledDistance_y === 0) ? "rgba(255,255,255,1)" : "rgba(0,0,0,1)");
		canvasContext.setLineDash([5, 3]);
		canvasContext.lineWidth = 2;
		canvasContext.stroke();
		canvasContext.closePath();
		// render the diagonal distance text
		if (coordinateDistance_y > 1 && coordinateDistance_x > 1) {
			var szHypotenuseText = g_oTechTools.formatMeasuredDistance(hypotenuse) + " " + g_oTechTools.g_szMeasurementSuffix + " " + Math.round(angle) + " " + g_oTechTools.c_szAngleMeasurementUnitsAbbreviation + ".";
			payload.lineLength = g_oTechTools.formatMeasuredDistance(hypotenuse) + " " + g_oTechTools.g_szMeasurementSuffix;
			payload.degrees = Math.round(angle) + " " + g_oTechTools.c_szAngleMeasurementUnitsAbbreviation;
			var areaTextSize = canvasContext.measureText(szHypotenuseText);

			// check to see if there is enough space in the rectangle to display the text.
			var iXDistance = Math.abs(g_oMarquee.g_iX - g_oMarquee.g_iOrigin_x);
			var iYDistance = Math.abs(g_oMarquee.g_iY - g_oMarquee.g_iOrigin_y);
			var bDisplayTextInMarquee = Math.sqrt((iXDistance * iXDistance) + (iYDistance * iYDistance)) > areaTextSize.width
				&& Math.abs(iYDistance) > iTextHeight
				&& Math.abs(iXDistance) > iTextHeight;

			// gather the begin point into an object for easy access & modification later.
			var oDiagonalDisplayText = { x: beginPoint_x, y: beginPoint_y };

			// if there is enough space to display the text then set up the canvas rotation to display it diagonally.
			if (bDisplayTextInMarquee) {
				// rotate
				canvasContext.translate(beginPoint_x + (coordinateDistance_x / 2), beginPoint_y + (coordinateDistance_y / 2));
				canvasContext.rotate(angle * Math.PI / 180);
				canvasContext.translate(-(beginPoint_x + (coordinateDistance_x / 2)), -(beginPoint_y + (coordinateDistance_y / 2)));
			}
			// Otherwise, identify where we need to place the text to ensure maximum viewing.
			else {
				// if we are to the right of the center of the canvas...
				if (oDiagonalDisplayText.x > oArtworkViewer.g_oCanvas.clientWidth / 2) {
					// ... display on the left side ...
					oDiagonalDisplayText.x -= iXDistance / 2 + areaTextSize.width / 2 + 20; // extra text appears on this side, so we include extra distance to avoid overlap with this text.
				}
				// ... otherwise if we are left of the center, display on the right side.
				else {
					oDiagonalDisplayText.x += iXDistance / 2 + areaTextSize.width / 2 + 10;
				}

				// if this would still leave the text outside of the bounds of the canvas reset and place it at the bottom or Top.
				if (oDiagonalDisplayText.x + ((coordinateDistance_x / 2) - (areaTextSize.width / 2)) + areaTextSize.width > oArtworkViewer.g_oCanvas.clientWidth) {
					oDiagonalDisplayText = { x: beginPoint_x, y: beginPoint_y };
					if (oDiagonalDisplayText.y > oArtworkViewer.g_oCanvas.clientHeight / 2) {
						oDiagonalDisplayText.y -= iYDistance / 2 + iTextHeight / 2 + 10;
					}
					else {
						oDiagonalDisplayText.y += iYDistance / 2 + iTextHeight / 2 + 10;
					}
				}
			}

			var szHypotenuseText = g_oTechTools.formatMeasuredDistance(hypotenuse) + " " + g_oTechTools.g_szMeasurementSuffix + " " + Math.round(angle) + " " + g_oTechTools.c_szAngleMeasurementUnitsAbbreviation + ".";
			
			var areaTextSize = canvasContext.measureText(szHypotenuseText);
			canvasContext.beginPath();
			canvasContext.fillStyle = "rgba(0,0,0,0.75)";
			canvasContext.rect(oDiagonalDisplayText.x + ((coordinateDistance_x / 2) - (areaTextSize.width / 2)) - g_oTechTools.g_oTextAreaHighlightBox.iBeginX, oDiagonalDisplayText.y + (coordinateDistance_y / 2) - g_oTechTools.g_oTextAreaHighlightBox.iBeginY, areaTextSize.width + g_oTechTools.g_oTextAreaHighlightBox.iWidth, g_oTechTools.g_oTextAreaHighlightBox.iHeight);
			canvasContext.fill();
			canvasContext.fillStyle = "#f3961c";
			canvasContext.fillText(szHypotenuseText, oDiagonalDisplayText.x + ((coordinateDistance_x / 2) - (areaTextSize.width / 2)), oDiagonalDisplayText.y + (coordinateDistance_y / 2) + 5);

			// only de-rotate the canvas if we previously rotated it.
			if (bDisplayTextInMarquee) {
				// de-rotate
				canvasContext.translate(beginPoint_x + (coordinateDistance_x / 2), beginPoint_y + (coordinateDistance_y / 2));
				canvasContext.rotate(-angle * Math.PI / 180);
				canvasContext.translate(-(beginPoint_x + (coordinateDistance_x / 2)), -(beginPoint_y + (coordinateDistance_y / 2)));
			}
		}

		canvasContext.translate(beginPoint_x, beginPoint_y);
		canvasContext.rotate(-90 * Math.PI / 180);
		canvasContext.translate(-beginPoint_x, -beginPoint_y);
		canvasContext.fillStyle = g_oTechTools.c_szFillStyle;

		if (scaledDistance_y > 0) {
			canvasContext.fillText(g_oTechTools.formatMeasuredDistance(scaledDistance_y) + " " + g_oTechTools.g_szMeasurementSuffix, beginPoint_x - coordinateDistance_y, beginPoint_y);
			payload.height = g_oTechTools.formatMeasuredDistance(scaledDistance_y) + " " + g_oTechTools.g_szMeasurementSuffix;
		}
	};

	/// <summary>
	/// Function to calculate the area measurement and render it in the UI.
	/// </summary>
	/// <param name="canvasContext">The canvas context.</param>
	/// <param name="beginPoint_x">The start X coordinate.</param>
	/// <param name="beginPoint_y">The start Y coordinate.</param>
	/// <param name="scaledDistance_x">The X coordinate distance (the distance between the begin and end points) scaled by the image width.</param>
	/// <param name="scaledDistance_y">The Y coordinate distance (the distance between the begin and end points) scaled by the image height.</param>
	/// <param name="coordinateDistance_x">The X coordinate distance (the distance between the begin and end points).</param>
	/// <param name="coordinateDistance_y">The Y coordinate distance (the distance between the begin and end points).</param>
	TechToolsUI.prototype.measureArea = function (oArtworkViewer, oAnnotationViewer, canvasContext, beginPoint_x, beginPoint_y, scaledDistance_x, scaledDistance_y, coordinateDistance_x, coordinateDistance_y, payload) {
		canvasContext.fillStyle = g_oTechTools.c_szFillStyle;
		canvasContext.font = g_oTechTools.c_szDisplayFont;
		canvasContext.textBaseline = g_oTechTools.c_szTextBaseline;
		canvasContext.textAlign = g_oTechTools.c_szTextAlign;

		var iTextHeight = 20;

		// if we are just drawing a line
		if (scaledDistance_x === 0 || scaledDistance_y === 0) {
			canvasContext.beginPath();
			canvasContext.moveTo(g_oMarquee.g_iOrigin_x, g_oMarquee.g_iOrigin_y);
			canvasContext.lineTo(g_oMarquee.g_iX, g_oMarquee.g_iY);
			canvasContext.strokeStyle = "rgba(255,255,255,1)";
			canvasContext.setLineDash([5, 3]);
			canvasContext.lineWidth = 2;
			canvasContext.stroke();
			canvasContext.closePath();
		};

		// X-Axis measurement text...if it is a non-zero measurement.
		if (scaledDistance_x > 0) {
			canvasContext.fillText(g_oTechTools.formatMeasuredDistance(scaledDistance_x) + " " + g_oTechTools.g_szMeasurementSuffix, beginPoint_x, beginPoint_y);
			payload.width = g_oTechTools.formatMeasuredDistance(scaledDistance_x) + " " + g_oTechTools.g_szMeasurementSuffix;
		};

		// Area measurement text.
		var area = g_oTechTools.formatMeasuredDistance(scaledDistance_x) * g_oTechTools.formatMeasuredDistance(scaledDistance_y);
		var szAreaText = g_oTechTools.formatMeasuredDistance(area) + " " + g_oTechTools.c_szAreaMeasurementAbbreviation + " " + g_oTechTools.g_szMeasurementSuffix;
		var areaTextSize = canvasContext.measureText(szAreaText);

		payload.area = szAreaText;

		canvasContext.beginPath();
		canvasContext.fillStyle = "rgba(0,0,0,0.75)";

		// Only display the area measurement if it is a non-zero measurement.
		if (area > 0) {
			// check to see if there is enough space in the rectangle to display the text.
			var iXDistance = Math.abs(g_oMarquee.g_iX - g_oMarquee.g_iOrigin_x);
			var iYDistance = Math.abs(g_oMarquee.g_iY - g_oMarquee.g_iOrigin_y);
			var bDisplayTextInMarquee = (iXDistance > areaTextSize.width)
				&& (iYDistance > iTextHeight)
				&& (iXDistance > iTextHeight);
			var oAreaTextLocation = { x: beginPoint_x, y: beginPoint_y };

			if (!bDisplayTextInMarquee) {
				// if we are to the left of the center of the canvas, place the text on the right, and vice versa.
				if (oAreaTextLocation.x > oArtworkViewer.g_oCanvas.clientWidth / 2) {
					oAreaTextLocation.x -= iXDistance / 2 + areaTextSize.width / 2 + 20;
				} else {
					oAreaTextLocation.x += iXDistance / 2 + areaTextSize.width / 2 + 10;
				}

				// if this would still leave the text outside of the bounds of the canvas reset and place it at the bottom or Top.
				if (oAreaTextLocation.x + ((coordinateDistance_x / 2) - (areaTextSize.width / 2)) + areaTextSize.width > oArtworkViewer.g_oCanvas.clientWidth) {
					oAreaTextLocation = { x: beginPoint_x, y: beginPoint_y };
					if (oAreaTextLocation.y > oArtworkViewer.g_oCanvas.clientHeight / 2) {
						oAreaTextLocation.y -= iYDistance / 2 + iTextHeight / 2 + 10;
					} else {
						oAreaTextLocation.y += iYDistance / 2 + iTextHeight / 2 + 10;
					}
				}
			}

			canvasContext.rect(oAreaTextLocation.x + ((coordinateDistance_x / 2) - (areaTextSize.width / 2)) - g_oTechTools.g_oTextAreaHighlightBox.iBeginX,
				oAreaTextLocation.y + (coordinateDistance_y / 2) - g_oTechTools.g_oTextAreaHighlightBox.iBeginY,
				areaTextSize.width + g_oTechTools.g_oTextAreaHighlightBox.iWidth,
				g_oTechTools.g_oTextAreaHighlightBox.iHeight
			);
			canvasContext.fill();
			canvasContext.fillStyle = "#f3961c";
			canvasContext.fillText(szAreaText, oAreaTextLocation.x + ((coordinateDistance_x / 2) - (areaTextSize.width / 2)), oAreaTextLocation.y + (coordinateDistance_y / 2) + 5);
		}

		// rotate the canvas for the Y axis text.
		canvasContext.translate(beginPoint_x, beginPoint_y);
		canvasContext.rotate(-90 * Math.PI / 180);
		canvasContext.translate(-beginPoint_x, -beginPoint_y);
		canvasContext.fillStyle = g_oTechTools.c_szFillStyle;

		// Y-Axis measurement text...if it is a non-zero measurement.
		if (scaledDistance_y > 0) {
			canvasContext.fillText(g_oTechTools.formatMeasuredDistance(scaledDistance_y) + " " + g_oTechTools.g_szMeasurementSuffix, beginPoint_x - coordinateDistance_y, beginPoint_y);
			payload.height = g_oTechTools.formatMeasuredDistance(scaledDistance_y) + " " + g_oTechTools.g_szMeasurementSuffix;
		}
	};

	/**
	 * Helper method to call the caliper redraw method without using 800 parameters
	 * @param {object} event The event
	 * @param {object} data Object containing all the needed parameters
	 */
	TechToolsUI.prototype.CaliperRedrawCaller = function (event, data) {
		CaliperRedraw(event, data.type, data.oArtworkViewer, data.oAnnotationViewer, data.canvasContext, data.canvasWidth, data.canvasHeight,
			data.beginPoint_x, data.beginPoint_y, data.coordinateDistance_x, data.coordinateDistance_y, data.measurement, data.szMeasurementText, data.fakeClick, data.redrawInPlace);
	};

	/**
	 * Redraws the caliper based on where the mouse is
	 * @param {object} event The event
	 * @param {number} type Enum of the type of measurement
	 * @param {object} oArtworkViewer The artwork viewer
	 * @param {object} oAnnotationViewer The annotation viewer
	 * @param {object} canvasContext The 2DContext object
	 * @param {number} canvasWidth The width of the canvas
	 * @param {number} canvasHeight The height of the canvas
	 * @param {number} beginPoint_x The start point of the draw
	 * @param {number} beginPoint_y The start point of the draw
	 * @param {number} coordinateDistance_x How far away on the X axis is the point
	 * @param {number} coordinateDistance_y How far away on the Y axis is the point
	 * @param {number} measurement The measurement itself
	 * @param {string} szMeasurementText The measurement in a user friendly format
	 * @param {boolean} fakeClick Whether we're faking a click
	 * @param {boolean} redrawInPlace Whether we're redrawing the caliper in place
	 */
	var CaliperRedraw = function (event, type, oArtworkViewer, oAnnotationViewer, canvasContext,
		canvasWidth, canvasHeight, beginPoint_x, beginPoint_y, coordinateDistance_x, coordinateDistance_y, measurement, szMeasurementText, fakeClick, redrawInPlace) {
		var isHorizontal = type === g_oTechTools.g_eMeasurementTypes.HORIZONTAL;
		measurement = measurement || null;
		fakeClick = fakeClick || null;

		canvasContext.save();

		var fDistanceToDraw = isHorizontal ? coordinateDistance_x : coordinateDistance_y;
		if (measurement) {
			fDistanceToDraw = measurement;
		}
		fDistanceToDraw = fDistanceToDraw * (oArtworkViewer.g_iZoomLevel / g_oTechTools.g_iOriginalZoomLevel);

		// force our own coords if faking the click
		var newCoords;
		if (!fakeClick) {
			newCoords = getClickCoords(event, oAnnotationViewer);
		}
		else {
			if (redrawInPlace) {
				newCoords = g_oSavedCalipers.GetLeftmostPoint(event); 
			}
			else {
				newCoords = GetNewFakeCoords(oArtworkViewer, oAnnotationViewer, fDistanceToDraw, isHorizontal, redrawInPlace);
			}
		}

		// Unrotate the canvas context
		canvasContext.setTransform(1, 0, 0, 1, 0, 0);

		var x = isHorizontal ? newCoords[0] : beginPoint_x;
		var y = isHorizontal ? beginPoint_y : newCoords[1];

		// Doesn't recurse anymore?
		if (isHorizontal) {
			DrawHorizontalCalliper(canvasContext, canvasWidth, canvasHeight, x, y, fDistanceToDraw, coordinateDistance_y, szMeasurementText);
		}
		else {
			DrawVerticalCalliper(canvasContext, canvasWidth, canvasHeight, x, y, fDistanceToDraw, szMeasurementText);
		}
	};

	/**
	 * Gets the faked coordinates to draw the caliper in a predetermined location
	 * @param {object} ArtworkViewer The artworkviewer
	 * @param {object} AnnotationViewer The annotationviewer
	 * @param {number} fDistanceToDraw how large the caliper is to be
	 * @param {bool} isHorizontal whether it's a horizontal caliper
	 * @returns {number[]} faked click coordinates
	 */
	var GetNewFakeCoords = function (ArtworkViewer, AnnotationViewer, fDistanceToDraw, isHorizontal) {
		if (!isHorizontal) {
			var h = $("#divContainer").height() + 10;
			return fakeClickCoords(0, h, AnnotationViewer);
		}

		var xCoord = calculateCentralXCoordinate(fDistanceToDraw);
		switch (g_oViewer.g_oCompareMode) {
			case eCompareMode.SideBySide:
				xCoord /= 2;
				break;
			case eCompareMode.SideBySideDiff:
				xCoord /= 3;
				break;
		}

		if (ArtworkViewer.g_szCanvasId === "CompareViewer") {
			xCoord *= 3;
		}

		return fakeClickCoords(xCoord, 0, AnnotationViewer);
	};

	/**
	 * Binds the relevant events for the caliper save handle event
	 * @param {object} oAnnotationViewer The annotation viewer object
	 * @param {object} canvasContext The canvas context for the artwork
	 * @param {number[]} coord The start coordinates
	 * @param {number} type Enum of the type of caliper
	 * @param {number} scaledDistance The scaled distance
	 */
	var BindCaliperSaveHandleEvents = function (oAnnotationViewer, canvasContext, coord, type, scaledDistance) {
		$(oAnnotationViewer.g_oCanvas).off('.calipersave');

		$(oAnnotationViewer.g_oCanvas).onFirst('pointermove.calipersave', function (e) {
			g_oSavedCalipers.HandleHover(e, canvasContext, coord, type, scaledDistance);
		});

		$(oAnnotationViewer.g_oCanvas).onFirst('pointerdown.calipersave', function (e) {
			// If we detect and handle the click
			if (g_oSavedCalipers.TryHandleClick(e, canvasContext, coord, type, scaledDistance)) {
				// Prevent other handlers from firing.
				e.stopImmediatePropagation();
				// Make sure the pointerup event doesn't trigger.
				$(oAnnotationViewer.g_oCanvas).off('pointerup.caliperdraw');
			}
		});
	};

	/**
	 * Event for when the a caliper is stopped being dragged
	 * @param {object} e The event
	 * @param {object} oArtworkViewer The artwork canvas object
	 * @param {object} oAnnotationViewer The annotation canvas object
	 * @param {object} canvasContext The 2dCanvasContext object
	 * @param {number[]} coord The coordinates
	 * @param {number} type Enum of the type of caliper
	 * @param {number} scaledDistance The calculated distance
	 */
	var CaliperMeasurementRedrawPointerUp = function (e, oArtworkViewer, oAnnotationViewer, canvasContext, coord, type, scaledDistance) {
		$(oAnnotationViewer.g_oCanvas).off('pointermove');
		$(oAnnotationViewer.g_oCanvas).off('pointerdown.calipersave');
		if (!oArtworkViewer.g_bMainCanvas || g_oSavedCalipers.MeasurementAlreadyExists(type, scaledDistance)) {
			return;
		}

		var newCoords = getClickCoords(e, oAnnotationViewer);
		if (type === g_oTechTools.g_eMeasurementTypes.HORIZONTAL) {
			newCoords[1] = coord[1];
		}
		else {
			newCoords[0] = coord[0];
		}

		g_oSavedCalipers.DrawSaveIcon(canvasContext, newCoords, type, scaledDistance);

		g_oSavedCalipers.StoreDrawPoints(newCoords[0], newCoords[1]);
		g_oSavedCalipers.StoreEvent(e);

		BindCaliperSaveHandleEvents(oAnnotationViewer, canvasContext, newCoords, type, scaledDistance);
	};

	/// <summary>
	/// Function to calculate the Horizontal Calliper measurement and render it in the UI.
	/// </summary>
	/// <param name="canvasContext">The canvas context.</param>
	/// <param name="beginPoint_x">The start X coordinate.</param>
	/// <param name="beginPoint_y">The start Y coordinate.</param>
	/// <param name="scaledDistance_x">The X coordinate distance (the distance between the begin and end points) scaled by the image width.</param>
	/// <param name="coordinateDistance_x">The X coordinate distance (the distance between the begin and end points).</param>
	/// <param name="coordinateDistance_y">The Y coordinate distance (the distance between the begin and end points).</param>
	/// <param name="canvasWidth">Width of the canvas.</param>
	/// <param name="canvasHeight">Height of the canvas.</param>
	/// <param name="canvasHalfWidth">The half width of the canvas.</param>
	/// <param name="canvasHalfHeight">The half height of the canvas.</param>
	var MeasureHorizontal = function (oArtworkViewer, oAnnotationViewer, canvasContext, beginPoint_x, beginPoint_y, scaledDistance_x, coordinateDistance_x, coordinateDistance_y, canvasWidth, canvasHeight, canvasHalfWidth, canvasHalfHeight) {
		var szMeasurementText = g_oTechTools.formatMeasuredDistance(scaledDistance_x) + " " + g_oTechTools.g_szMeasurementSuffix;

		DrawHorizontalCalliper(canvasContext, canvasWidth, canvasHeight, beginPoint_x, beginPoint_y, coordinateDistance_x, coordinateDistance_y, szMeasurementText);

		$(oAnnotationViewer.g_oCanvas).off('pointerup');
		$(oAnnotationViewer.g_oCanvas).one('pointerup', function (e) {
			CaliperMeasurementEnd(e, oArtworkViewer, oAnnotationViewer, canvasContext, beginPoint_x, beginPoint_y, MeasurementInMM(scaledDistance_x),
				coordinateDistance_x, coordinateDistance_y, canvasWidth, canvasHeight, szMeasurementText, g_oTechTools.g_eMeasurementTypes.HORIZONTAL);
		});
	};

	/// <summary>
	/// Helper method to draw the Horizontal Calliper overlay in the UI.
	/// </summary>
	/// <param name="canvasContext">The canvas context.</param>
	/// <param name="canvasWidth">Width of the canvas.</param>
	/// <param name="canvasHeight">Height of the canvas.</param>
	/// <param name="beginPoint_x">The start X coordinate.</param>
	/// <param name="beginPoint_y">The start Y coordinate.</param>
	/// <param name="coordinateDistance_x">The X coordinate distance (the distance between the begin and end points).</param>
	/// <param name="coordinateDistance_y">The Y coordinate distance (the distance between the begin and end points).</param>
	/// <param name="szMeasurementText">The measurement text.</param>
	var DrawHorizontalCalliper = function (canvasContext, canvasWidth, canvasHeight, beginPoint_x, beginPoint_y, coordinateDistance_x, coordinateDistance_y, szMeasurementText) {
		canvasContext.clearRect(0, 0, canvasWidth, canvasHeight);
		canvasContext.beginPath();
		canvasContext.rect(0, 0, canvasWidth, canvasHeight);
		canvasContext.fillStyle = "rgba(0,0,0,0.75)";
		canvasContext.fill();
		canvasContext.clearRect(beginPoint_x, 0, coordinateDistance_x, canvasHeight);

		canvasContext.translate(beginPoint_x, beginPoint_y);
		canvasContext.rotate(-90 * Math.PI / 180);
		canvasContext.translate(-beginPoint_x, -beginPoint_y);
		canvasContext.fillStyle = g_oTechTools.c_szFillStyle;
		canvasContext.font = g_oTechTools.c_szDisplayFont;
		canvasContext.textBaseline = g_oTechTools.c_szTextBaseline;
		canvasContext.textAlign = g_oTechTools.c_szTextAlign;
		canvasContext.fillText(szMeasurementText, beginPoint_x, beginPoint_y);
		canvasContext.restore();
	};

	/// <summary>
	/// Function to calculate the Vertical Calliper measurement and render it in the UI.
	/// </summary>
	/// <param name="canvasContext">The canvas context.</param>
	/// <param name="beginPoint_x">The start X coordinate.</param>
	/// <param name="beginPoint_y">The start Y coordinate.</param>
	/// <param name="scaledDistance_y">The Y coordinate distance (the distance between the begin and end points) scaled by the image height.</param>
	/// <param name="coordinateDistance_x">The X coordinate distance (the distance between the begin and end points).</param>
	/// <param name="coordinateDistance_y">The Y coordinate distance (the distance between the begin and end points).</param>
	/// <param name="canvasWidth">Width of the canvas.</param>
	/// <param name="canvasHeight">Height of the canvas.</param>
	/// <param name="canvasHalfWidth">The half width of the canvas.</param>
	/// <param name="canvasHalfHeight">The half height of the canvas.</param>
	var MeasureVertical = function (oArtworkViewer, oAnnotationViewer, canvasContext, beginPoint_x, beginPoint_y, scaledDistance_y, coordinateDistance_x, coordinateDistance_y, canvasWidth, canvasHeight, canvasHalfWidth, canvasHalfHeight) {
		var szMeasurementText = g_oTechTools.formatMeasuredDistance(scaledDistance_y) + " " + g_oTechTools.g_szMeasurementSuffix;

		DrawVerticalCalliper(canvasContext, canvasWidth, canvasHeight, beginPoint_x, beginPoint_y, coordinateDistance_y, szMeasurementText);

		$(oAnnotationViewer.g_oCanvas).off("pointerup");
		$(oAnnotationViewer.g_oCanvas).one('pointerup', function (e) {
			CaliperMeasurementEnd(e, oArtworkViewer, oAnnotationViewer, canvasContext, beginPoint_x, beginPoint_y, MeasurementInMM(scaledDistance_y),
				coordinateDistance_x, coordinateDistance_y, canvasWidth, canvasHeight, szMeasurementText, g_oTechTools.g_eMeasurementTypes.VERTICAL);
		});
	};

	/**
	 * The event for when a caliper measuremen
	 * @param {object} e The event
	 * @param {object} oArtworkViewer The artwork viewer object
	 * @param {object} oAnnotationViewer The annotation viewer object
	 * @param {object} canvasContext The 2dCanvasContext object
	 * @param {number} beginPoint_x The x coordinate of the point dragged from
	 * @param {number} beginPoint_y The y coordinate of the point dragged from
	 * @param {number} measurement The measurement itself
	 * @param {number} coordinateDistance_x How far on the x axis it was drawn
	 * @param {number} coordinateDistance_y How far on the y axis it was drawn
	 * @param {number} canvasWidth The width of the canvas
	 * @param {number} canvasHeight The height of the canvas
	 * @param {string} szMeasurementText The measurement in the user's format as a string
	 * @param {number} type Enum of the type of measurement
	 */
	var CaliperMeasurementEnd = function (e, oArtworkViewer, oAnnotationViewer, canvasContext, beginPoint_x, beginPoint_y, measurement,
		coordinateDistance_x, coordinateDistance_y, canvasWidth, canvasHeight, szMeasurementText, type) {
		g_oSavedCalipers.g_iCurMeas = measurement;
		g_oSavedCalipers.StoreDrawPoints(beginPoint_x, beginPoint_y);
		g_oSavedCalipers.StoreEvent(e);
		g_oTechTools.CaliperMeasurePointerUp(oArtworkViewer, oAnnotationViewer, canvasContext, beginPoint_x, beginPoint_y, measurement,
			coordinateDistance_x, coordinateDistance_y, canvasWidth, canvasHeight, szMeasurementText, type);
	};

	/**
	 * Event for when a caliper measurement is finished being drawn. Binds the events for redrawing it
	 * @param {object} oArtworkViewer The artwork viewer object
	 * @param {object} oAnnotationViewer The annotation viewer object
	 * @param {object} canvasContext The 2dCanvasContext object
	 * @param {number} beginPoint_x The x coordinate of the point dragged from
	 * @param {number} beginPoint_y The y coordinate of the point dragged from
	 * @param {number} scaledDistance The distance dragged
	 * @param {number} coordinateDistance_x How far on the x axis it was drawn
	 * @param {number} coordinateDistance_y How far on the y axis it was drawn
	 * @param {number} canvasWidth The width of the canvas
	 * @param {number} canvasHeight The height of the canvas
	 * @param {string} measurementText The measurement in the user's format as a string
	 * @param {number} type Enum of the type of measurement
	 */
	TechToolsUI.prototype.CaliperMeasurePointerUp = function (oArtworkViewer, oAnnotationViewer, canvasContext, beginPoint_x, beginPoint_y, scaledDistance,
		coordinateDistance_x, coordinateDistance_y, canvasWidth, canvasHeight, measurementText, type) {
		$(oAnnotationViewer.g_oCanvas).off('pointerdown');

		$(oAnnotationViewer.g_oCanvas).off('pointermove');
		$(".annotationViewer").off('pointermove');

		if (oArtworkViewer.g_bMainCanvas && !g_oSavedCalipers.MeasurementAlreadyExists(type, scaledDistance)) {
			g_oSavedCalipers.DrawSaveIcon(canvasContext, [beginPoint_x, beginPoint_y], type, scaledDistance);
			BindCaliperSaveHandleEvents(oAnnotationViewer, canvasContext, [beginPoint_x, beginPoint_y], type, scaledDistance);
		}

		$(oAnnotationViewer.g_oCanvas).on('pointerdown.caliperdraw', function (e) {
			// Hide the toolbar if it's still there
			$("#divTechToolsDropDown").slideUp(200);

			CaliperRedraw(e, type, oArtworkViewer, oAnnotationViewer, canvasContext,
				canvasWidth, canvasHeight, beginPoint_x, beginPoint_y, coordinateDistance_x, coordinateDistance_y, null, measurementText, false, false);

			$(oAnnotationViewer.g_oCanvas).off('pointerup');
			$(oAnnotationViewer.g_oCanvas).on('pointerup.caliperdraw', function (e) {
				CaliperMeasurementRedrawPointerUp(e, oArtworkViewer, oAnnotationViewer, canvasContext, [beginPoint_x, beginPoint_y], type, scaledDistance);
			});

			$(oAnnotationViewer.g_oCanvas).off('pointermove');
			$(oAnnotationViewer.g_oCanvas).on('pointermove.caliperdraw', function (e) {
				CaliperRedraw(e, type, oArtworkViewer, oAnnotationViewer, canvasContext,
					canvasWidth, canvasHeight, beginPoint_x, beginPoint_y, coordinateDistance_x, coordinateDistance_y, null, measurementText, false, false);
			});
		});
	};

	/**
	 * Returns whether currently dragging the mouse will redraw a caliper
	 * @returns {bool} True if currently caliper redraw events are bound.
	 */
	TechToolsUI.prototype.IsCaliperRedrawMode = function () {
		return this.IsCaliper(this.g_iSelectedMeasurementType) && g_oSavedCalipers.CaliperEventsBound($("#AnnotationViewer"), "pointerdown");
	};

	/**
	 * Returns whether the given measurement type is a caliper
	 * @param {number} type Enum of the measurement type
	 * @returns {bool} True if caliper measurement.
	 */
	TechToolsUI.prototype.IsCaliper = function (type) {
		return type === this.g_eMeasurementTypes.HORIZONTAL || type === this.g_eMeasurementTypes.VERTICAL;
	};

	/// <summary>
	/// Helper method to draw the Horizontal Calliper overlay in the UI.
	/// </summary>
	/// <param name="canvasContext">The canvas context.</param>
	/// <param name="canvasWidth">Width of the canvas.</param>
	/// <param name="canvasHeight">Height of the canvas.</param>
	/// <param name="beginPoint_x">The start X coordinate.</param>
	/// <param name="beginPoint_y">The start Y coordinate.</param>
	/// <param name="coordinateDistance_y">The Y coordinate distance (the distance between the begin and end points).</param>
	/// <param name="szMeasurementText">The measurement text.</param>
	var DrawVerticalCalliper = function (canvasContext, canvasWidth, canvasHeight, beginPoint_x, beginPoint_y, coordinateDistance_y, szMeasurementText) {
		canvasContext.clearRect(0, 0, canvasWidth, canvasHeight);
		canvasContext.beginPath();
		canvasContext.rect(0, 0, canvasWidth, canvasHeight);
		canvasContext.fillStyle = "rgba(0,0,0,0.75)";
		canvasContext.fill();
		canvasContext.clearRect(0, beginPoint_y, canvasWidth, coordinateDistance_y);

		canvasContext.fillStyle = g_oTechTools.c_szFillStyle;
		canvasContext.font = g_oTechTools.c_szDisplayFont;
		canvasContext.textBaseline = g_oTechTools.c_szTextBaseline;
		canvasContext.textAlign = g_oTechTools.c_szTextAlign;
		canvasContext.fillText(szMeasurementText, beginPoint_x, beginPoint_y);
		canvasContext.restore();
	};

	/**
	 * Transforms coordinates based on rotation and offsets.
	 * @param {int} iStartX - The starting x coordinate.
	 * @param {int} iStartY - The starting y coordinate.
	 * @param {int} iEndX - The ending x coordinate.
	 * @param {int} iEndY - The ending y coordinate.
	 * @param {int} iDragOffset_x - The drag offset of the x axis.
	 * @param {int} iDragOffset_y - The drag offset of the y axis.
	 * @param {int} iCenterShift_x - The centershift on the x axis.
	 * @param {int} iCenterShift_y - The centershift on the y axis.
	 * @param {object} oArtworkViewer - The artwork viewer.
	 * @returns {array} - Transformed coordinates.
	 */
	TechToolsUI.prototype.transformCoordinates = function (iStartX, iStartY, iEndX, iEndY, iDragOffset_x, iDragOffset_y, iCenterShift_x, iCenterShift_y, oArtworkViewer) {
		var iBeginPoint_x = iStartX;
		var iBeginPoint_y = iStartY;
		var iEndPoint_x = iEndX;
		var iEndPoint_y = iEndY;

		// Calculate the positions based on the canvas rotation.
		switch (oArtworkViewer.g_iRotDegrees) {
			case 90:
				iBeginPoint_x += iDragOffset_x * 2;
				iBeginPoint_x -= iDragOffset_y;
				iBeginPoint_y += iDragOffset_y * 2;
				iBeginPoint_y += iDragOffset_x;
				iEndPoint_x += iDragOffset_x * 2;
				iEndPoint_x -= iDragOffset_y;
				iEndPoint_y += iDragOffset_y * 2;
				iEndPoint_y += iDragOffset_x;
				break;

			case 180:
				iBeginPoint_x += iDragOffset_x * 3;
				iBeginPoint_y += iDragOffset_y * 3;
				iEndPoint_x += iDragOffset_x * 3;
				iEndPoint_y += iDragOffset_y * 3;
				break;

			case 270:
				iBeginPoint_x += iDragOffset_x * 2;
				iBeginPoint_x += iDragOffset_y;
				iBeginPoint_y += iDragOffset_y * 2;
				iBeginPoint_y -= iDragOffset_x;
				iEndPoint_x += iDragOffset_x * 2;
				iEndPoint_x += iDragOffset_y;
				iEndPoint_y += iDragOffset_y * 2;
				iEndPoint_y -= iDragOffset_x;
				break;

			default:
				iBeginPoint_x += iDragOffset_x;
				iBeginPoint_y += iDragOffset_y;
				iEndPoint_x += iDragOffset_x;
				iEndPoint_y += iDragOffset_y;
				break;
		}

		// Calculate the compare offset of the canvas.
		var compareOffset_x, compareOffset_y;
		var co = g_oCompare.calculateCompareOffsetInPx(oArtworkViewer);
		compareOffset_x = co.x;
		compareOffset_y = co.y;

		// Get the compare rotation of the canvas.
		var iCompareRotation = g_oCompare.getCompareRotation(oArtworkViewer);

		// Ensure the image width is scaled to the image size.
		var iImageWidth = oArtworkViewer.g_iScaledImageWidth;
		var iImageHeight = oArtworkViewer.g_iScaledImageHeight;

		// If we have a compare rotation of 90 or 270, swap the image width and height.
		if (iCompareRotation == 90 || iCompareRotation == 270) {
			iImageWidth = oArtworkViewer.g_iScaledImageHeight;
			iImageHeight = oArtworkViewer.g_iScaledImageWidth;
		}

		// Update the begin and end points.
		iBeginPoint_x -= (iCenterShift_x + iDragOffset_x + compareOffset_x);
		iBeginPoint_y -= (iCenterShift_y + iDragOffset_y + compareOffset_y);
		iEndPoint_x -= (iCenterShift_x + iDragOffset_x + compareOffset_x);
		iEndPoint_y -= (iCenterShift_y + iDragOffset_y + compareOffset_y);

		// Ratio the begin and end points.
		iBeginPoint_x /= iImageWidth;
		iBeginPoint_y /= iImageHeight;
		iEndPoint_x /= iImageWidth;
		iEndPoint_y /= iImageHeight;

		return [[iBeginPoint_x, iBeginPoint_y], [iEndPoint_x, iEndPoint_y]];
	}

	/// <summary>
	/// Helper method that is called when the pointer up event is fired during a technical tools measurement action.
	/// </summary>
	/// <param name="event">The event.</param>
	/// <param name="beginPoint_x">The start X coordinate.</param>
	/// <param name="beginPoint_y">The start Y coordinate.</param>
	/// <param name="endPoint_x">The end X coordinate.</param>
	/// <param name="endPoint_y">The end Y coordinate.</param>
	/// <param name="iDragOffset_x">The X-axis drag offset.</param>
	/// <param name="iDragOffset_y">The Y-axis drag offset.</param>
	/// <param name="iCenterShift_x">The X-axis centre shift. The distance from the edge of the screen to the edge of image.</param>
	/// <param name="iCenterShift_y">The Y-axis centre shift. The distance from the edge of the screen to the edge of image.</param>
	/// <param name="iImageWidth">Width of the image.</param>
	/// <param name="iImageHeight">Height of the image.</param>
	TechToolsUI.prototype.measurementPointerUp = function (event, oArtworkViewer, oSyncCanvas, beginPoint_x, beginPoint_y, endPoint_x, endPoint_y, iDragOffset_x, iDragOffset_y, iCenterShift_x, iCenterShift_y, iImageWidth, iImageHeight) {
		
		// Outline the co-ordinates for the annotation handle.
		var iPointX = Math.max(g_oMarquee.g_iX, g_oMarquee.g_iOrigin_x) + g_oAnnotationActions.g_iDragRectOffset;
		var iPointY = Math.min(g_oMarquee.g_iY, g_oMarquee.g_iOrigin_y);

		// Get the transformed coordinates.
		var trueCoords = g_oMarquee.transformMarqueeCoordinatesForRotation(oArtworkViewer, false);
		var transformedCoordinates = TechToolsUI.prototype.transformCoordinates(trueCoords.iBeginPoint_X, trueCoords.iBeginPoint_Y, trueCoords.iEndPoint_X, trueCoords.iEndPoint_Y, iDragOffset_x, iDragOffset_y, iCenterShift_x, iCenterShift_y, oArtworkViewer);

		// Determine if the coordinates are out of bounds.
		var bOutOfBounds = transformedCoordinates.concat().sort(sortAnnotationCoords.returnXMin)[0][0] < 0
			|| transformedCoordinates.concat().sort(sortAnnotationCoords.returnXMax)[0][0] > 1
			|| transformedCoordinates.concat().sort(sortAnnotationCoords.returnYMin)[0][1] < 0
			|| transformedCoordinates.concat().sort(sortAnnotationCoords.returnYMax)[0][1] > 1;

		// De-rotate.
		oArtworkViewer.g_oAnnotationCanvas.g_oContext.save();
		g_oMarquee.derotateCanvasContext(oArtworkViewer.g_oAnnotationCanvas.g_oContext, oArtworkViewer.g_oAnnotationCanvas, oArtworkViewer.g_oAnnotationCanvas.g_oCanvas.width, oArtworkViewer.g_oAnnotationCanvas.g_oCanvas.height, oArtworkViewer.g_oAnnotationCanvas.g_oCanvas.width / 2, oArtworkViewer.g_oAnnotationCanvas.g_oCanvas.height / 2);

		// Draw the annotation handle.
		if (g_oTechTools.g_iSelectedMeasurementType != g_oTechTools.g_eMeasurementTypes.TEXT &&
			g_oTechTools.g_iSelectedMeasurementType != g_oTechTools.g_eMeasurementTypes.VERTICAL &&
			g_oTechTools.g_iSelectedMeasurementType != g_oTechTools.g_eMeasurementTypes.HORIZONTAL &&
			g_oTechTools.g_iSelectedMeasurementType != g_oTechTools.g_eMeasurementTypes.COLOURDENSITY && // We draw this later
			g_oTechTools.g_iSelectedMeasurementType != g_oTechTools.g_eMeasurementTypes.BARCODE) { // We draw this later

			if (!g_oViewer.g_bReadOnly && oArtworkViewer.g_bMainCanvas && !bOutOfBounds) {

				// Draw the annotation handle.
				g_oAnnotationActions.drawAnnotationHandle([iPointX, iPointY], g_oSettings.g_oUserSettings.AnnotationColour, true, eAnnotationHandleTypes.CreateNewAnnotation, oArtworkViewer.g_oAnnotationCanvas.g_oContext);

				// Create the handle data object array for the single handle.
				var oHandleData = [{
					handleX: iPointX,
					handleY: iPointY,
					annotationCoordinates: transformedCoordinates,
					annotationData: g_oPayload
				}];

				// Set the pointer move event.
				changeCanvasFunction('#AnnotationViewer', "pointermove.annotationUI", function (e) {
					AnnotationAction.prototype.mouseMoveAnnotationHandles(e, oArtworkViewer, g_oAnnotationActions.g_oAnnotationCanvas, oHandleData, eAnnotationHandleTypes.CreateNewAnnotation);
				});

				// Set the pointer down event.
				changeCanvasFunction("#AnnotationViewer", "pointerdown.annotationUI", function (e) {
					AnnotationAction.prototype.mouseClickAnnotationHandles(e, oArtworkViewer, g_oAnnotationActions.g_oAnnotationCanvas, oHandleData, eAnnotationHandleTypes.CreateNewAnnotation);
				});
			}
		}

		// Revert.
		oArtworkViewer.g_oAnnotationCanvas.g_oContext.restore();

		switch (g_oTechTools.g_iSelectedMeasurementType) {
			case g_oTechTools.g_eMeasurementTypes.COLOURDENSITY:
				g_oPayload.type = eAnnotationTypes.ColourDensityMeasurement;
				break;
			case g_oTechTools.g_eMeasurementTypes.BARCODE:
				g_oPayload.type = eAnnotationTypes.BarcodeMeasurement;
				break;
			case g_oTechTools.g_eMeasurementTypes.AREA:
				g_oPayload.type = eAnnotationTypes.AreaMeasurement;
				break;
			case g_oTechTools.g_eMeasurementTypes.POINTTOPOINT:
				g_oPayload.type = eAnnotationTypes.PointToPointMeasurement;
				break;
			case g_oTechTools.g_eMeasurementTypes.TEXT:
				g_oPayload.type = eAnnotationTypes.TextMeasurement;
				break;
			case g_oTechTools.g_eMeasurementTypes.VERTICAL:
				g_oPayload.type = eAnnotationTypes.VerticalCalliperMeasurement;
				break;
			case g_oTechTools.g_eMeasurementTypes.HORIZONTAL:
				g_oPayload.type = eAnnotationTypes.HorizontalCalliperMeasurement;
				break;
		}

		// If we are measuring a barcode, text or colour density.
		if ((g_oTechTools.g_iSelectedMeasurementType === g_oTechTools.g_eMeasurementTypes.BARCODE) ||
			(g_oTechTools.g_iSelectedMeasurementType === g_oTechTools.g_eMeasurementTypes.COLOURDENSITY) ||
			(g_oTechTools.g_iSelectedMeasurementType === g_oTechTools.g_eMeasurementTypes.TEXT)) {

			// We want a densitometer reading, text measurement or barcode scan instead!
			var examTypeCode = g_oTechTools.g_eExamTypes.COLOURDENSITY;

			// Determine the selected measurement type.
			switch (g_oTechTools.g_iSelectedMeasurementType) {

				case g_oTechTools.g_eMeasurementTypes.BARCODE:
					examTypeCode = g_oTechTools.g_eExamTypes.BARCODE;

					// Clear any previous barcode measurement data for this canvas.
					g_oTechTools.g_oBarcodeMeasurementArray = g_oTechTools.g_oBarcodeMeasurementArray.filter(function (obj) {
						return obj.ArtworkCanvasId != oArtworkViewer.g_szCanvasId;
					});
					break;

				case g_oTechTools.g_eMeasurementTypes.TEXT:
					examTypeCode = g_oTechTools.g_eExamTypes.TEXT;
					if (!g_oSettings.g_oUserSettings.ShowAnnotations) {
						$("#HideAnnotations").click();		// We're creating a new annotation...so show the annotations if currently hidden.
					}
					break;

				default:
					// Leave the exam type code as zero.
			}

			// Take a copy of the begin and end points.
			var g_iBeginPoint_x = beginPoint_x;
			var g_iBeginPoint_y = beginPoint_y;
			var g_iEndPoint_x = endPoint_x;
			var g_iEndPoint_y = endPoint_y;

			// Calculate the positions based on the canvas rotation.
			var oTransformedCoords = TechToolsUI.prototype.transformCoordinates(beginPoint_x, beginPoint_y, endPoint_x, endPoint_y, iDragOffset_x, iDragOffset_y, iCenterShift_x, iCenterShift_y, oArtworkViewer);
			beginPoint_x = oTransformedCoords[0][0];
			beginPoint_y = oTransformedCoords[0][1];
			endPoint_x = oTransformedCoords[1][0];
			endPoint_y = oTransformedCoords[1][1];

			// Get the compare rotation of the canvas (again)
			var iCompareRotation = g_oCompare.getCompareRotation(oArtworkViewer);

			// If this is a real time render for the colour density tool.
			// Barcode real time renders are created at the time of scanning.
			if (g_oViewer.g_oArtworkViewer.isViewerUsingRealtimeRender() && g_oTechTools.g_iSelectedMeasurementType == g_oTechTools.g_eMeasurementTypes.COLOURDENSITY) {

				// Update the points to be relative to the real time render image, rather than the whole image.
				beginPoint_x = g_iBeginPoint_x / oArtworkViewer.g_oCanvas.width;
				beginPoint_y = g_iBeginPoint_y / oArtworkViewer.g_oCanvas.height;
				endPoint_x = g_iEndPoint_x / oArtworkViewer.g_oCanvas.width;
				endPoint_y = g_iEndPoint_y / oArtworkViewer.g_oCanvas.height;

				// These cases orientate the begin/end X & Y coordinates to the server image which won't have been rotated.
				switch (g_oTechTools.g_oArtworkViewer.g_iRotDegrees) {
					case 90:
						var tempValue = beginPoint_x;
						beginPoint_x = beginPoint_y;
						beginPoint_y = 1 - tempValue;

						tempValue = endPoint_x;
						endPoint_x = endPoint_y;
						endPoint_y = 1 - tempValue;
						break;

					case 180:
						beginPoint_x = 1 - beginPoint_x;
						beginPoint_y = 1 - beginPoint_y;

						endPoint_x = 1 - endPoint_x;
						endPoint_y = 1 - endPoint_y;
						break;

					case 270:
						var tempValue = beginPoint_x;
						beginPoint_x = 1 - beginPoint_y;
						beginPoint_y = tempValue;

						tempValue = endPoint_x;
						endPoint_x = 1 - endPoint_y;
						endPoint_y = tempValue;
						break;

					default:
						// Do nothing as it's in the correct orientation.
						break;
				}
			}

			// If the canvas has compare rotation.
			if (iCompareRotation > 0) {

				// Rotate the begin points.
				var oRotatedAnnotationDraw = oArtworkViewer.rotate(beginPoint_x, beginPoint_y, 0.5, 0.5, -iCompareRotation);
				beginPoint_x = oRotatedAnnotationDraw.rotated_x;
				beginPoint_y = oRotatedAnnotationDraw.rotated_y;

				// Rotate the end points.
				var oRotatedAnnotationDraw = oArtworkViewer.rotate(endPoint_x, endPoint_y, 0.5, 0.5, -iCompareRotation);
				endPoint_x = oRotatedAnnotationDraw.rotated_x;
				endPoint_y = oRotatedAnnotationDraw.rotated_y;
			}

			// If this is a density barcode or text measurement, and we cannot show the side bar.
			if (g_oTechTools.g_iSelectedMeasurementType == g_oTechTools.g_eMeasurementTypes.COLOURDENSITY ||
				g_oTechTools.g_iSelectedMeasurementType == g_oTechTools.g_eMeasurementTypes.BARCODE ||
				g_oTechTools.g_iSelectedMeasurementType == g_oTechTools.g_eMeasurementTypes.TEXT) {

				// If we cannot show the side bar due to not having separations.
				if ((!g_oViewer.g_oArtworkViewer.hasSeparations()) ||
					(g_oViewer.g_oCompareMode != eCompareMode.NoCompare && !g_oCompare.g_oCompareViewer.hasSeparations())) {

					// Display a warning message.
					g_oGreenlightMessages.displayWarningBubble(g_oTechTools.c_szInfoMsgNoSeparationsShown);

					// Redraw the canvas.
					oArtworkViewer.g_oAnnotationCanvas.redraw(false);

					// Do not examine the image.
					return;
				}
			}

			// Examine the image.
			g_oTechTools.examineImage(
				oArtworkViewer,
				oArtworkViewer.g_oAnnotationCanvas,
				Math.min(beginPoint_x, endPoint_x),
				Math.min(beginPoint_y, endPoint_y),
				Math.max(beginPoint_x, endPoint_x),
				Math.max(beginPoint_y, endPoint_y),
				examTypeCode
			);

			// Show the separations slide out if we're NOT looking for text.
			if (($("#divSepDiv").css("display") === "none") &&
				(g_oTechTools.g_iSelectedMeasurementType !== g_oTechTools.g_eMeasurementTypes.TEXT)) {

				// Show the separations side bar.
				g_oTechTools.showSeperationsSideBar(g_oTechTools.g_iSelectedMeasurementType !== g_oTechTools.g_eMeasurementTypes.BARCODE);
			}
		}
	};

	/**
	 * Called when the document has been changed.
	 */
	TechToolsUI.prototype.docChangeEvent = function () {

		// Clear any previous barcode measurement data.
		g_oTechTools.clearBarcodeMeasurementArray();

		// Get the index of the approval document combo control.
		var oComboControl = comboControl_GetControlById("approvalNameComboControl", false);

		// If the combo control has been found and a document has been selected.
		if (oComboControl != null && oComboControl.selectedDocumentIndex != -1) {

			// Get the selected document.
			var oDocument = oComboControl.documents[oComboControl.selectedDocumentIndex];

			// Set the document details.
			g_oTechTools.g_iDocumentId = oDocument.greenlightDocumentId;
			g_oTechTools.g_iApprovalId = oDocument.greenlightApprovalId;
		}
		else {
			g_oTechTools.g_iDocumentId = 0;
			g_oTechTools.g_iApprovalId = 0;
		}
		
		// If the document is a PDF.
		if (documentHasSeparations(g_oTechTools.g_oArtworkViewer.g_oDoc.documentType, g_oTechTools.g_oArtworkViewer.g_oDoc.pages.length)) {

			// Enable PDF specific measurements.
			$("#tblTechTools").show();
			$("#btnTechTools").show();
			$("#divTechToolsBarcode").show();
			$("#divTechToolsDensity").show();
			$("#divTechToolsText").show();
		}
		// If this is a threeD or svg document.
		else if (g_oTechTools.g_oArtworkViewer.g_oDoc.documentType == eDocumentTypes.ThreeD || documentDisplaysAsSVG(g_oTechTools.g_oArtworkViewer.g_oDoc.documentType)) {

			// Disable the tech tools.
			$("#tblTechTools").hide();
			$("#btnTechTools").hide();
			$("#divTechToolsBarcode").hide();
			$("#divTechToolsDensity").hide();
			$("#divTechToolsText").hide();
		}
		// If the document is any other type of document.
		else {

			// Disable PDF specific measurements.
			$("#tblTechTools").show();
			$("#btnTechTools").show();
			$("#divTechToolsBarcode").hide();
			$("#divTechToolsDensity").hide();
			$("#divTechToolsText").hide();
		}
	};

	/// <summary>
	/// Called when the Text Measurement annotation needs to collect the text content.
	/// If this is a result of the creation of a new Text Measurement Annotation then
	/// the text content and text measurement words array will be populated with the
	/// info returned by the examineImage_CH function.
	/// If the text content and text measurement words array are empty then this event
	/// has been called by a pre-existing text measurement annotation that needs to
	/// know which words it should highlight. The words array is not stored in the
	/// database and is worked out when the annotation is loaded from the database.
	/// </summary>
	/// <param name="oAnnotation">
	/// The annotation object to be populated with the text measurement words.
	/// </param>
	TechToolsUI.prototype.getTextMeasurementText = function (oData) {
		// Extract the objects from the published data.
		var oAnnotation = oData.oAnnotation;
		var oArtworkCanvas = oData.oArtworkCanvas;
		var oAnnotationCanvas = oData.oAnnotationCanvas;

		// If we already have words from a previous Text Measurement (which we shouldn't but you never know)...
		if (oAnnotation.g_oTextMeasurementWordsArray.length > 0 ||
			(oAnnotation.g_szTextContent !== undefined && oAnnotation.g_szTextContent.length > 0)) {
			oAnnotation.g_oTextMeasurementWordsArray.length = 0;	// ...clear the array by resetting it's length.
		}

		if (g_oTechTools.g_szTextMeasurementTextContent.length === 0) {
			// If we're populating a previously saved annotation we have to re-retrieve the measured text...
			var begin_x = oAnnotation.g_oMarqueeDrawArray[0][0];
			var begin_y = oAnnotation.g_oMarqueeDrawArray[0][1];
			var end_x = oAnnotation.g_oMarqueeDrawArray[1][0];
			var end_y = oAnnotation.g_oMarqueeDrawArray[1][1];
			var iAnnotationId = oAnnotation.id;
			g_oTechTools.examineImage(oArtworkCanvas, oAnnotationCanvas, begin_x, begin_y, end_x, end_y, g_oTechTools.g_eExamTypes.TEXT, iAnnotationId);
		}
		else {
			// ...Else just serve up the text measurement content we currently have.
			oAnnotation.g_szTextContent = g_oTechTools.g_szTextMeasurementTextContent;
			oAnnotation.g_oTextMeasurementWordsArray = deepCopyArray(g_oTechTools.g_oTextMeasurementWordsArray);

			// Clear the Tech Tools text measurement variables for the next annotation that needs to retrieve the measurement text.
			g_oTechTools.g_szTextMeasurementTextContent = "";
			g_oTechTools.g_oTextMeasurementWordsArray.length = 0;
		}
	};

	/// <summary>
	/// Helper function to iterate through the TextElement object array and set all the IsTextVisible
	/// properties to the specified value.
	/// </summary>
	/// <param name="oTextElementArray">The text element array.</param>
	/// <param name="bIsVisible">The boolean value that the IsTextVisible property is to be set to.</param>
	TechToolsUI.prototype.setTextMeasurementWordVisibility = function (oTextElementArray, bIsVisible) {
		for (var i = 0; i < oTextElementArray.length; i++) {
			oTextElementArray.IsTextVisible = bIsVisible;

			for (var j = 0; j < oTextElementArray[i].ChildTextElements.length; j++) {
				oTextElementArray[i].ChildTextElements[j].IsTextVisible = bIsVisible;
			}
		}
	};

	/**
	 * Registers the approvals events.
	 * @param {object} oEventService - The event service we are registering the events to.
	 */
	TechToolsUI.prototype.RegisterEvents = function (oEventService) {
		g_oTechTools.g_oEvents = oEventService;
		g_oTechTools.g_oEvents.subscribe("changeDoc", g_oTechTools.docChangeEvent);
		g_oTechTools.g_oEvents.subscribe("getTextMeasurementText", g_oTechTools.getTextMeasurementText);
	};

	// Add the Tech Tools UI object to the window.
	window.TechToolsUI = TechToolsUI;
}());